// Guardian AI Admin Service Protocol Definitions
// Subdomain: Ad Funnel
// Version: v1

// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none,json_types=true"
// @generated from file guardianai/v1/admin/ad_funnel.proto (package guardianai.v1.admin, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp, TimestampJson } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file guardianai/v1/admin/ad_funnel.proto.
 */
export const file_guardianai_v1_admin_ad_funnel: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_timestamp]);

/**
 * @generated from message guardianai.v1.admin.AdFunnel
 */
export type AdFunnel = Message<"guardianai.v1.admin.AdFunnel"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Admin-defined reference name
   *
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * Empty for non-YouTube
   *
   * @generated from field: string youtube_video_id = 3;
   */
  youtubeVideoId: string;

  /**
   * @generated from field: string headline = 4;
   */
  headline: string;

  /**
   * @generated from field: string description = 5;
   */
  description: string;

  /**
   * @generated from field: string cta_text = 6;
   */
  ctaText: string;

  /**
   * @generated from field: string thumbnail_url = 7;
   */
  thumbnailUrl: string;

  /**
   * @generated from field: bool is_active = 8;
   */
  isActive: boolean;

  /**
   * User ID
   *
   * @generated from field: string created_by = 9;
   */
  createdBy: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 10;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 11;
   */
  updatedAt?: Timestamp;

  /**
   * Book/Campaign details
   *
   * @generated from field: guardianai.v1.admin.FunnelType funnel_type = 12;
   */
  funnelType: FunnelType;

  /**
   * @generated from field: guardianai.v1.admin.CampaignStatus status = 13;
   */
  status: CampaignStatus;

  /**
   * @generated from field: string book_id = 14;
   */
  bookId: string;

  /**
   * @generated from field: string slug = 15;
   */
  slug: string;

  /**
   * @generated from field: string source = 16;
   */
  source: string;

  /**
   * @generated from field: string medium = 17;
   */
  medium: string;

  /**
   * @generated from field: string campaign_code = 18;
   */
  campaignCode: string;

  /**
   * @generated from field: string content_code = 19;
   */
  contentCode: string;

  /**
   * @generated from field: string term = 20;
   */
  term: string;

  /**
   * @generated from field: google.protobuf.Timestamp start_at = 21;
   */
  startAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp end_at = 22;
   */
  endAt?: Timestamp;

  /**
   * @generated from field: string geo_target = 23;
   */
  geoTarget: string;

  /**
   * @generated from field: string notes = 24;
   */
  notes: string;

  /**
   * @generated from field: string product_id = 25;
   */
  productId: string;
};

/**
 * @generated from message guardianai.v1.admin.AdFunnel
 */
export type AdFunnelJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;

  /**
   * Admin-defined reference name
   *
   * @generated from field: string name = 2;
   */
  name?: string;

  /**
   * Empty for non-YouTube
   *
   * @generated from field: string youtube_video_id = 3;
   */
  youtubeVideoId?: string;

  /**
   * @generated from field: string headline = 4;
   */
  headline?: string;

  /**
   * @generated from field: string description = 5;
   */
  description?: string;

  /**
   * @generated from field: string cta_text = 6;
   */
  ctaText?: string;

  /**
   * @generated from field: string thumbnail_url = 7;
   */
  thumbnailUrl?: string;

  /**
   * @generated from field: bool is_active = 8;
   */
  isActive?: boolean;

  /**
   * User ID
   *
   * @generated from field: string created_by = 9;
   */
  createdBy?: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 10;
   */
  createdAt?: TimestampJson;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 11;
   */
  updatedAt?: TimestampJson;

  /**
   * Book/Campaign details
   *
   * @generated from field: guardianai.v1.admin.FunnelType funnel_type = 12;
   */
  funnelType?: FunnelTypeJson;

  /**
   * @generated from field: guardianai.v1.admin.CampaignStatus status = 13;
   */
  status?: CampaignStatusJson;

  /**
   * @generated from field: string book_id = 14;
   */
  bookId?: string;

  /**
   * @generated from field: string slug = 15;
   */
  slug?: string;

  /**
   * @generated from field: string source = 16;
   */
  source?: string;

  /**
   * @generated from field: string medium = 17;
   */
  medium?: string;

  /**
   * @generated from field: string campaign_code = 18;
   */
  campaignCode?: string;

  /**
   * @generated from field: string content_code = 19;
   */
  contentCode?: string;

  /**
   * @generated from field: string term = 20;
   */
  term?: string;

  /**
   * @generated from field: google.protobuf.Timestamp start_at = 21;
   */
  startAt?: TimestampJson;

  /**
   * @generated from field: google.protobuf.Timestamp end_at = 22;
   */
  endAt?: TimestampJson;

  /**
   * @generated from field: string geo_target = 23;
   */
  geoTarget?: string;

  /**
   * @generated from field: string notes = 24;
   */
  notes?: string;

  /**
   * @generated from field: string product_id = 25;
   */
  productId?: string;
};

/**
 * Describes the message guardianai.v1.admin.AdFunnel.
 * Use `create(AdFunnelSchema)` to create a new message.
 */
export const AdFunnelSchema: GenMessage<AdFunnel, {jsonType: AdFunnelJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_ad_funnel, 0);

/**
 * @generated from message guardianai.v1.admin.Book
 */
export type Book = Message<"guardianai.v1.admin.Book"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string slug = 2;
   */
  slug: string;

  /**
   * @generated from field: string title = 3;
   */
  title: string;

  /**
   * @generated from field: string subtitle = 4;
   */
  subtitle: string;

  /**
   * @generated from field: string description = 5;
   */
  description: string;

  /**
   * @generated from field: string short_description = 6;
   */
  shortDescription: string;

  /**
   * @generated from field: string headline = 7;
   */
  headline: string;

  /**
   * @generated from field: string value_proposition = 8;
   */
  valueProposition: string;

  /**
   * @generated from field: string author_name = 9;
   */
  authorName: string;

  /**
   * @generated from field: string author_profile = 10;
   */
  authorProfile: string;

  /**
   * @generated from field: string publisher_name = 11;
   */
  publisherName: string;

  /**
   * YYYY-MM-DD
   *
   * @generated from field: string publication_date = 12;
   */
  publicationDate: string;

  /**
   * @generated from field: string primary_language = 13;
   */
  primaryLanguage: string;

  /**
   * @generated from field: string primary_cover_asset_id = 14;
   */
  primaryCoverAssetId: string;

  /**
   * @generated from field: string primary_audience = 15;
   */
  primaryAudience: string;

  /**
   * @generated from field: string primary_call_to_action = 16;
   */
  primaryCallToAction: string;

  /**
   * @generated from field: string edition = 17;
   */
  edition: string;

  /**
   * @generated from field: string series_name = 18;
   */
  seriesName: string;

  /**
   * @generated from field: int32 series_position = 19;
   */
  seriesPosition: number;

  /**
   * @generated from field: int32 page_count = 20;
   */
  pageCount: number;

  /**
   * @generated from field: string reading_level = 21;
   */
  readingLevel: string;

  /**
   * @generated from field: int32 copyright_year = 22;
   */
  copyrightYear: number;

  /**
   * @generated from field: string contributors = 23;
   */
  contributors: string;

  /**
   * @generated from field: string foreword_author = 24;
   */
  forewordAuthor: string;

  /**
   * @generated from field: string illustrator = 25;
   */
  illustrator: string;

  /**
   * @generated from field: string translator = 26;
   */
  translator: string;

  /**
   * @generated from field: repeated string categories = 27;
   */
  categories: string[];

  /**
   * @generated from field: repeated string subjects = 28;
   */
  subjects: string[];

  /**
   * @generated from field: repeated string bisac_categories = 29;
   */
  bisacCategories: string[];

  /**
   * @generated from field: repeated string keywords = 30;
   */
  keywords: string[];

  /**
   * DRAFT, PUBLISHED, etc.
   *
   * @generated from field: string status = 31;
   */
  status: string;

  /**
   * @generated from field: string created_by = 32;
   */
  createdBy: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 33;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 34;
   */
  updatedAt?: Timestamp;

  /**
   * @generated from field: repeated guardianai.v1.admin.BookIdentifier identifiers = 35;
   */
  identifiers: BookIdentifier[];

  /**
   * @generated from field: repeated guardianai.v1.admin.BookOffer offers = 36;
   */
  offers: BookOffer[];

  /**
   * @generated from field: repeated guardianai.v1.admin.BookBenefit benefits = 37;
   */
  benefits: BookBenefit[];

  /**
   * @generated from field: repeated guardianai.v1.admin.BookAudience audiences = 38;
   */
  audiences: BookAudience[];

  /**
   * @generated from field: repeated guardianai.v1.admin.BookChapter chapters = 39;
   */
  chapters: BookChapter[];

  /**
   * @generated from field: repeated guardianai.v1.admin.BookResource resources = 40;
   */
  resources: BookResource[];

  /**
   * @generated from field: repeated guardianai.v1.admin.BookFAQ faqs = 41;
   */
  faqs: BookFAQ[];

  /**
   * @generated from field: repeated guardianai.v1.admin.BookEndorsement endorsements = 42;
   */
  endorsements: BookEndorsement[];

  /**
   * @generated from field: guardianai.v1.admin.BookPositioning positioning = 43;
   */
  positioning?: BookPositioning;

  /**
   * @generated from field: guardianai.v1.admin.BookSeoControls seo = 44;
   */
  seo?: BookSeoControls;

  /**
   * @generated from field: repeated guardianai.v1.admin.BookCompanionTool companion_tools = 45;
   */
  companionTools: BookCompanionTool[];
};

/**
 * @generated from message guardianai.v1.admin.Book
 */
export type BookJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;

  /**
   * @generated from field: string slug = 2;
   */
  slug?: string;

  /**
   * @generated from field: string title = 3;
   */
  title?: string;

  /**
   * @generated from field: string subtitle = 4;
   */
  subtitle?: string;

  /**
   * @generated from field: string description = 5;
   */
  description?: string;

  /**
   * @generated from field: string short_description = 6;
   */
  shortDescription?: string;

  /**
   * @generated from field: string headline = 7;
   */
  headline?: string;

  /**
   * @generated from field: string value_proposition = 8;
   */
  valueProposition?: string;

  /**
   * @generated from field: string author_name = 9;
   */
  authorName?: string;

  /**
   * @generated from field: string author_profile = 10;
   */
  authorProfile?: string;

  /**
   * @generated from field: string publisher_name = 11;
   */
  publisherName?: string;

  /**
   * YYYY-MM-DD
   *
   * @generated from field: string publication_date = 12;
   */
  publicationDate?: string;

  /**
   * @generated from field: string primary_language = 13;
   */
  primaryLanguage?: string;

  /**
   * @generated from field: string primary_cover_asset_id = 14;
   */
  primaryCoverAssetId?: string;

  /**
   * @generated from field: string primary_audience = 15;
   */
  primaryAudience?: string;

  /**
   * @generated from field: string primary_call_to_action = 16;
   */
  primaryCallToAction?: string;

  /**
   * @generated from field: string edition = 17;
   */
  edition?: string;

  /**
   * @generated from field: string series_name = 18;
   */
  seriesName?: string;

  /**
   * @generated from field: int32 series_position = 19;
   */
  seriesPosition?: number;

  /**
   * @generated from field: int32 page_count = 20;
   */
  pageCount?: number;

  /**
   * @generated from field: string reading_level = 21;
   */
  readingLevel?: string;

  /**
   * @generated from field: int32 copyright_year = 22;
   */
  copyrightYear?: number;

  /**
   * @generated from field: string contributors = 23;
   */
  contributors?: string;

  /**
   * @generated from field: string foreword_author = 24;
   */
  forewordAuthor?: string;

  /**
   * @generated from field: string illustrator = 25;
   */
  illustrator?: string;

  /**
   * @generated from field: string translator = 26;
   */
  translator?: string;

  /**
   * @generated from field: repeated string categories = 27;
   */
  categories?: string[];

  /**
   * @generated from field: repeated string subjects = 28;
   */
  subjects?: string[];

  /**
   * @generated from field: repeated string bisac_categories = 29;
   */
  bisacCategories?: string[];

  /**
   * @generated from field: repeated string keywords = 30;
   */
  keywords?: string[];

  /**
   * DRAFT, PUBLISHED, etc.
   *
   * @generated from field: string status = 31;
   */
  status?: string;

  /**
   * @generated from field: string created_by = 32;
   */
  createdBy?: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 33;
   */
  createdAt?: TimestampJson;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 34;
   */
  updatedAt?: TimestampJson;

  /**
   * @generated from field: repeated guardianai.v1.admin.BookIdentifier identifiers = 35;
   */
  identifiers?: BookIdentifierJson[];

  /**
   * @generated from field: repeated guardianai.v1.admin.BookOffer offers = 36;
   */
  offers?: BookOfferJson[];

  /**
   * @generated from field: repeated guardianai.v1.admin.BookBenefit benefits = 37;
   */
  benefits?: BookBenefitJson[];

  /**
   * @generated from field: repeated guardianai.v1.admin.BookAudience audiences = 38;
   */
  audiences?: BookAudienceJson[];

  /**
   * @generated from field: repeated guardianai.v1.admin.BookChapter chapters = 39;
   */
  chapters?: BookChapterJson[];

  /**
   * @generated from field: repeated guardianai.v1.admin.BookResource resources = 40;
   */
  resources?: BookResourceJson[];

  /**
   * @generated from field: repeated guardianai.v1.admin.BookFAQ faqs = 41;
   */
  faqs?: BookFAQJson[];

  /**
   * @generated from field: repeated guardianai.v1.admin.BookEndorsement endorsements = 42;
   */
  endorsements?: BookEndorsementJson[];

  /**
   * @generated from field: guardianai.v1.admin.BookPositioning positioning = 43;
   */
  positioning?: BookPositioningJson;

  /**
   * @generated from field: guardianai.v1.admin.BookSeoControls seo = 44;
   */
  seo?: BookSeoControlsJson;

  /**
   * @generated from field: repeated guardianai.v1.admin.BookCompanionTool companion_tools = 45;
   */
  companionTools?: BookCompanionToolJson[];
};

/**
 * Describes the message guardianai.v1.admin.Book.
 * Use `create(BookSchema)` to create a new message.
 */
export const BookSchema: GenMessage<Book, {jsonType: BookJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_ad_funnel, 1);

/**
 * @generated from message guardianai.v1.admin.BookIdentifier
 */
export type BookIdentifier = Message<"guardianai.v1.admin.BookIdentifier"> & {
  /**
   * Kindle, Paperback, Hardcover, Audiobook, Other
   *
   * @generated from field: string format_id = 1;
   */
  formatId: string;

  /**
   * ISBN-10, ISBN-13, ASIN, SKU
   *
   * @generated from field: string type = 2;
   */
  type: string;

  /**
   * @generated from field: string value = 3;
   */
  value: string;
};

/**
 * @generated from message guardianai.v1.admin.BookIdentifier
 */
export type BookIdentifierJson = {
  /**
   * Kindle, Paperback, Hardcover, Audiobook, Other
   *
   * @generated from field: string format_id = 1;
   */
  formatId?: string;

  /**
   * ISBN-10, ISBN-13, ASIN, SKU
   *
   * @generated from field: string type = 2;
   */
  type?: string;

  /**
   * @generated from field: string value = 3;
   */
  value?: string;
};

/**
 * Describes the message guardianai.v1.admin.BookIdentifier.
 * Use `create(BookIdentifierSchema)` to create a new message.
 */
export const BookIdentifierSchema: GenMessage<BookIdentifier, {jsonType: BookIdentifierJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_ad_funnel, 2);

/**
 * @generated from message guardianai.v1.admin.BookOffer
 */
export type BookOffer = Message<"guardianai.v1.admin.BookOffer"> & {
  /**
   * @generated from field: string format = 1;
   */
  format: string;

  /**
   * @generated from field: string marketplace = 2;
   */
  marketplace: string;

  /**
   * @generated from field: string currency = 3;
   */
  currency: string;

  /**
   * @generated from field: double display_price = 4;
   */
  displayPrice: number;

  /**
   * @generated from field: string standard_destination_url = 5;
   */
  standardDestinationUrl: string;

  /**
   * @generated from field: string attribution_destination_url = 6;
   */
  attributionDestinationUrl: string;

  /**
   * @generated from field: string availability = 7;
   */
  availability: string;

  /**
   * @generated from field: string button_label = 8;
   */
  buttonLabel: string;

  /**
   * @generated from field: int32 display_order = 9;
   */
  displayOrder: number;

  /**
   * @generated from field: bool active = 10;
   */
  active: boolean;

  /**
   * Estimated Google Ads value of an Amazon outbound click
   *
   * @generated from field: double conversion_value = 11;
   */
  conversionValue: number;
};

/**
 * @generated from message guardianai.v1.admin.BookOffer
 */
export type BookOfferJson = {
  /**
   * @generated from field: string format = 1;
   */
  format?: string;

  /**
   * @generated from field: string marketplace = 2;
   */
  marketplace?: string;

  /**
   * @generated from field: string currency = 3;
   */
  currency?: string;

  /**
   * @generated from field: double display_price = 4;
   */
  displayPrice?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: string standard_destination_url = 5;
   */
  standardDestinationUrl?: string;

  /**
   * @generated from field: string attribution_destination_url = 6;
   */
  attributionDestinationUrl?: string;

  /**
   * @generated from field: string availability = 7;
   */
  availability?: string;

  /**
   * @generated from field: string button_label = 8;
   */
  buttonLabel?: string;

  /**
   * @generated from field: int32 display_order = 9;
   */
  displayOrder?: number;

  /**
   * @generated from field: bool active = 10;
   */
  active?: boolean;

  /**
   * Estimated Google Ads value of an Amazon outbound click
   *
   * @generated from field: double conversion_value = 11;
   */
  conversionValue?: number | "NaN" | "Infinity" | "-Infinity";
};

/**
 * Describes the message guardianai.v1.admin.BookOffer.
 * Use `create(BookOfferSchema)` to create a new message.
 */
export const BookOfferSchema: GenMessage<BookOffer, {jsonType: BookOfferJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_ad_funnel, 3);

/**
 * @generated from message guardianai.v1.admin.BookBenefit
 */
export type BookBenefit = Message<"guardianai.v1.admin.BookBenefit"> & {
  /**
   * @generated from field: string title = 1;
   */
  title: string;

  /**
   * @generated from field: string description = 2;
   */
  description: string;

  /**
   * @generated from field: int32 display_order = 3;
   */
  displayOrder: number;
};

/**
 * @generated from message guardianai.v1.admin.BookBenefit
 */
export type BookBenefitJson = {
  /**
   * @generated from field: string title = 1;
   */
  title?: string;

  /**
   * @generated from field: string description = 2;
   */
  description?: string;

  /**
   * @generated from field: int32 display_order = 3;
   */
  displayOrder?: number;
};

/**
 * Describes the message guardianai.v1.admin.BookBenefit.
 * Use `create(BookBenefitSchema)` to create a new message.
 */
export const BookBenefitSchema: GenMessage<BookBenefit, {jsonType: BookBenefitJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_ad_funnel, 4);

/**
 * @generated from message guardianai.v1.admin.BookAudience
 */
export type BookAudience = Message<"guardianai.v1.admin.BookAudience"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string description = 2;
   */
  description: string;

  /**
   * @generated from field: int32 display_order = 3;
   */
  displayOrder: number;
};

/**
 * @generated from message guardianai.v1.admin.BookAudience
 */
export type BookAudienceJson = {
  /**
   * @generated from field: string name = 1;
   */
  name?: string;

  /**
   * @generated from field: string description = 2;
   */
  description?: string;

  /**
   * @generated from field: int32 display_order = 3;
   */
  displayOrder?: number;
};

/**
 * Describes the message guardianai.v1.admin.BookAudience.
 * Use `create(BookAudienceSchema)` to create a new message.
 */
export const BookAudienceSchema: GenMessage<BookAudience, {jsonType: BookAudienceJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_ad_funnel, 5);

/**
 * @generated from message guardianai.v1.admin.BookChapter
 */
export type BookChapter = Message<"guardianai.v1.admin.BookChapter"> & {
  /**
   * @generated from field: string part_number = 1;
   */
  partNumber: string;

  /**
   * @generated from field: string part_title = 2;
   */
  partTitle: string;

  /**
   * @generated from field: string chapter_number = 3;
   */
  chapterNumber: string;

  /**
   * @generated from field: string chapter_title = 4;
   */
  chapterTitle: string;

  /**
   * @generated from field: string chapter_summary = 5;
   */
  chapterSummary: string;

  /**
   * @generated from field: int32 display_order = 6;
   */
  displayOrder: number;
};

/**
 * @generated from message guardianai.v1.admin.BookChapter
 */
export type BookChapterJson = {
  /**
   * @generated from field: string part_number = 1;
   */
  partNumber?: string;

  /**
   * @generated from field: string part_title = 2;
   */
  partTitle?: string;

  /**
   * @generated from field: string chapter_number = 3;
   */
  chapterNumber?: string;

  /**
   * @generated from field: string chapter_title = 4;
   */
  chapterTitle?: string;

  /**
   * @generated from field: string chapter_summary = 5;
   */
  chapterSummary?: string;

  /**
   * @generated from field: int32 display_order = 6;
   */
  displayOrder?: number;
};

/**
 * Describes the message guardianai.v1.admin.BookChapter.
 * Use `create(BookChapterSchema)` to create a new message.
 */
export const BookChapterSchema: GenMessage<BookChapter, {jsonType: BookChapterJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_ad_funnel, 6);

/**
 * @generated from message guardianai.v1.admin.BookResource
 */
export type BookResource = Message<"guardianai.v1.admin.BookResource"> & {
  /**
   * @generated from field: string resource_type = 1;
   */
  resourceType: string;

  /**
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * @generated from field: string asset_id = 4;
   */
  assetId: string;

  /**
   * @generated from field: string destination_url = 5;
   */
  destinationUrl: string;

  /**
   * @generated from field: bool requires_registration = 6;
   */
  requiresRegistration: boolean;

  /**
   * @generated from field: int32 display_order = 7;
   */
  displayOrder: number;

  /**
   * @generated from field: bool active = 8;
   */
  active: boolean;
};

/**
 * @generated from message guardianai.v1.admin.BookResource
 */
export type BookResourceJson = {
  /**
   * @generated from field: string resource_type = 1;
   */
  resourceType?: string;

  /**
   * @generated from field: string title = 2;
   */
  title?: string;

  /**
   * @generated from field: string description = 3;
   */
  description?: string;

  /**
   * @generated from field: string asset_id = 4;
   */
  assetId?: string;

  /**
   * @generated from field: string destination_url = 5;
   */
  destinationUrl?: string;

  /**
   * @generated from field: bool requires_registration = 6;
   */
  requiresRegistration?: boolean;

  /**
   * @generated from field: int32 display_order = 7;
   */
  displayOrder?: number;

  /**
   * @generated from field: bool active = 8;
   */
  active?: boolean;
};

/**
 * Describes the message guardianai.v1.admin.BookResource.
 * Use `create(BookResourceSchema)` to create a new message.
 */
export const BookResourceSchema: GenMessage<BookResource, {jsonType: BookResourceJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_ad_funnel, 7);

/**
 * @generated from message guardianai.v1.admin.BookFAQ
 */
export type BookFAQ = Message<"guardianai.v1.admin.BookFAQ"> & {
  /**
   * @generated from field: string question = 1;
   */
  question: string;

  /**
   * @generated from field: string answer = 2;
   */
  answer: string;

  /**
   * @generated from field: int32 display_order = 3;
   */
  displayOrder: number;

  /**
   * @generated from field: bool active = 4;
   */
  active: boolean;
};

/**
 * @generated from message guardianai.v1.admin.BookFAQ
 */
export type BookFAQJson = {
  /**
   * @generated from field: string question = 1;
   */
  question?: string;

  /**
   * @generated from field: string answer = 2;
   */
  answer?: string;

  /**
   * @generated from field: int32 display_order = 3;
   */
  displayOrder?: number;

  /**
   * @generated from field: bool active = 4;
   */
  active?: boolean;
};

/**
 * Describes the message guardianai.v1.admin.BookFAQ.
 * Use `create(BookFAQSchema)` to create a new message.
 */
export const BookFAQSchema: GenMessage<BookFAQ, {jsonType: BookFAQJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_ad_funnel, 8);

/**
 * @generated from message guardianai.v1.admin.BookEndorsement
 */
export type BookEndorsement = Message<"guardianai.v1.admin.BookEndorsement"> & {
  /**
   * @generated from field: string reviewer_name = 1;
   */
  reviewerName: string;

  /**
   * @generated from field: string reviewer_role = 2;
   */
  reviewerRole: string;

  /**
   * @generated from field: string review_text = 3;
   */
  reviewText: string;

  /**
   * @generated from field: string source_name = 4;
   */
  sourceName: string;

  /**
   * @generated from field: string source_url = 5;
   */
  sourceUrl: string;

  /**
   * @generated from field: string review_date = 6;
   */
  reviewDate: string;

  /**
   * @generated from field: bool verified = 7;
   */
  verified: boolean;

  /**
   * @generated from field: bool permission_confirmed = 8;
   */
  permissionConfirmed: boolean;

  /**
   * @generated from field: int32 display_order = 9;
   */
  displayOrder: number;

  /**
   * @generated from field: bool active = 10;
   */
  active: boolean;
};

/**
 * @generated from message guardianai.v1.admin.BookEndorsement
 */
export type BookEndorsementJson = {
  /**
   * @generated from field: string reviewer_name = 1;
   */
  reviewerName?: string;

  /**
   * @generated from field: string reviewer_role = 2;
   */
  reviewerRole?: string;

  /**
   * @generated from field: string review_text = 3;
   */
  reviewText?: string;

  /**
   * @generated from field: string source_name = 4;
   */
  sourceName?: string;

  /**
   * @generated from field: string source_url = 5;
   */
  sourceUrl?: string;

  /**
   * @generated from field: string review_date = 6;
   */
  reviewDate?: string;

  /**
   * @generated from field: bool verified = 7;
   */
  verified?: boolean;

  /**
   * @generated from field: bool permission_confirmed = 8;
   */
  permissionConfirmed?: boolean;

  /**
   * @generated from field: int32 display_order = 9;
   */
  displayOrder?: number;

  /**
   * @generated from field: bool active = 10;
   */
  active?: boolean;
};

/**
 * Describes the message guardianai.v1.admin.BookEndorsement.
 * Use `create(BookEndorsementSchema)` to create a new message.
 */
export const BookEndorsementSchema: GenMessage<BookEndorsement, {jsonType: BookEndorsementJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_ad_funnel, 9);

/**
 * @generated from message guardianai.v1.admin.BookPositioning
 */
export type BookPositioning = Message<"guardianai.v1.admin.BookPositioning"> & {
  /**
   * @generated from field: string primary_headline = 1;
   */
  primaryHeadline: string;

  /**
   * @generated from field: string value_proposition = 2;
   */
  valueProposition: string;

  /**
   * @generated from field: string central_problem = 3;
   */
  centralProblem: string;

  /**
   * @generated from field: string reader_outcome = 4;
   */
  readerOutcome: string;

  /**
   * @generated from field: repeated string key_benefits = 5;
   */
  keyBenefits: string[];

  /**
   * @generated from field: repeated string intended_readers = 6;
   */
  intendedReaders: string[];

  /**
   * @generated from field: repeated string differentiators = 7;
   */
  differentiators: string[];

  /**
   * @generated from field: repeated string practical_artifacts = 8;
   */
  practicalArtifacts: string[];

  /**
   * @generated from field: repeated string companion_tools = 9;
   */
  companionTools: string[];

  /**
   * @generated from field: string research_basis = 10;
   */
  researchBasis: string;

  /**
   * @generated from field: repeated string key_themes = 11;
   */
  keyThemes: string[];

  /**
   * @generated from field: string author_credibility = 12;
   */
  authorCredibility: string;
};

/**
 * @generated from message guardianai.v1.admin.BookPositioning
 */
export type BookPositioningJson = {
  /**
   * @generated from field: string primary_headline = 1;
   */
  primaryHeadline?: string;

  /**
   * @generated from field: string value_proposition = 2;
   */
  valueProposition?: string;

  /**
   * @generated from field: string central_problem = 3;
   */
  centralProblem?: string;

  /**
   * @generated from field: string reader_outcome = 4;
   */
  readerOutcome?: string;

  /**
   * @generated from field: repeated string key_benefits = 5;
   */
  keyBenefits?: string[];

  /**
   * @generated from field: repeated string intended_readers = 6;
   */
  intendedReaders?: string[];

  /**
   * @generated from field: repeated string differentiators = 7;
   */
  differentiators?: string[];

  /**
   * @generated from field: repeated string practical_artifacts = 8;
   */
  practicalArtifacts?: string[];

  /**
   * @generated from field: repeated string companion_tools = 9;
   */
  companionTools?: string[];

  /**
   * @generated from field: string research_basis = 10;
   */
  researchBasis?: string;

  /**
   * @generated from field: repeated string key_themes = 11;
   */
  keyThemes?: string[];

  /**
   * @generated from field: string author_credibility = 12;
   */
  authorCredibility?: string;
};

/**
 * Describes the message guardianai.v1.admin.BookPositioning.
 * Use `create(BookPositioningSchema)` to create a new message.
 */
export const BookPositioningSchema: GenMessage<BookPositioning, {jsonType: BookPositioningJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_ad_funnel, 10);

/**
 * @generated from message guardianai.v1.admin.BookSeoControls
 */
export type BookSeoControls = Message<"guardianai.v1.admin.BookSeoControls"> & {
  /**
   * @generated from field: string seo_title = 1;
   */
  seoTitle: string;

  /**
   * @generated from field: string meta_description = 2;
   */
  metaDescription: string;

  /**
   * @generated from field: string canonical_url = 3;
   */
  canonicalUrl: string;

  /**
   * @generated from field: string search_preview_image = 4;
   */
  searchPreviewImage: string;

  /**
   * @generated from field: string og_title = 5;
   */
  ogTitle: string;

  /**
   * @generated from field: string og_description = 6;
   */
  ogDescription: string;

  /**
   * @generated from field: string og_image = 7;
   */
  ogImage: string;

  /**
   * @generated from field: string twitter_title = 8;
   */
  twitterTitle: string;

  /**
   * @generated from field: string twitter_description = 9;
   */
  twitterDescription: string;

  /**
   * @generated from field: string twitter_image = 10;
   */
  twitterImage: string;

  /**
   * @generated from field: string primary_keyword = 11;
   */
  primaryKeyword: string;

  /**
   * @generated from field: repeated string supporting_keywords = 12;
   */
  supportingKeywords: string[];

  /**
   * @generated from field: bool index = 13;
   */
  index: boolean;

  /**
   * @generated from field: bool follow = 14;
   */
  follow: boolean;

  /**
   * @generated from field: bool sitemap_inclusion = 15;
   */
  sitemapInclusion: boolean;

  /**
   * @generated from field: string last_substantive_update = 16;
   */
  lastSubstantiveUpdate: string;

  /**
   * @generated from field: string google_ads_conversion_id = 17;
   */
  googleAdsConversionId: string;

  /**
   * @generated from field: string google_ads_conversion_label = 18;
   */
  googleAdsConversionLabel: string;

  /**
   * @generated from field: repeated guardianai.v1.admin.BookSitelink sitelinks = 19;
   */
  sitelinks: BookSitelink[];
};

/**
 * @generated from message guardianai.v1.admin.BookSeoControls
 */
export type BookSeoControlsJson = {
  /**
   * @generated from field: string seo_title = 1;
   */
  seoTitle?: string;

  /**
   * @generated from field: string meta_description = 2;
   */
  metaDescription?: string;

  /**
   * @generated from field: string canonical_url = 3;
   */
  canonicalUrl?: string;

  /**
   * @generated from field: string search_preview_image = 4;
   */
  searchPreviewImage?: string;

  /**
   * @generated from field: string og_title = 5;
   */
  ogTitle?: string;

  /**
   * @generated from field: string og_description = 6;
   */
  ogDescription?: string;

  /**
   * @generated from field: string og_image = 7;
   */
  ogImage?: string;

  /**
   * @generated from field: string twitter_title = 8;
   */
  twitterTitle?: string;

  /**
   * @generated from field: string twitter_description = 9;
   */
  twitterDescription?: string;

  /**
   * @generated from field: string twitter_image = 10;
   */
  twitterImage?: string;

  /**
   * @generated from field: string primary_keyword = 11;
   */
  primaryKeyword?: string;

  /**
   * @generated from field: repeated string supporting_keywords = 12;
   */
  supportingKeywords?: string[];

  /**
   * @generated from field: bool index = 13;
   */
  index?: boolean;

  /**
   * @generated from field: bool follow = 14;
   */
  follow?: boolean;

  /**
   * @generated from field: bool sitemap_inclusion = 15;
   */
  sitemapInclusion?: boolean;

  /**
   * @generated from field: string last_substantive_update = 16;
   */
  lastSubstantiveUpdate?: string;

  /**
   * @generated from field: string google_ads_conversion_id = 17;
   */
  googleAdsConversionId?: string;

  /**
   * @generated from field: string google_ads_conversion_label = 18;
   */
  googleAdsConversionLabel?: string;

  /**
   * @generated from field: repeated guardianai.v1.admin.BookSitelink sitelinks = 19;
   */
  sitelinks?: BookSitelinkJson[];
};

/**
 * Describes the message guardianai.v1.admin.BookSeoControls.
 * Use `create(BookSeoControlsSchema)` to create a new message.
 */
export const BookSeoControlsSchema: GenMessage<BookSeoControls, {jsonType: BookSeoControlsJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_ad_funnel, 11);

/**
 * @generated from message guardianai.v1.admin.BookSitelink
 */
export type BookSitelink = Message<"guardianai.v1.admin.BookSitelink"> & {
  /**
   * @generated from field: string sitelink_text = 1;
   */
  sitelinkText: string;

  /**
   * @generated from field: string description_1 = 2;
   */
  description1: string;

  /**
   * @generated from field: string description_2 = 3;
   */
  description2: string;

  /**
   * @generated from field: string final_url = 4;
   */
  finalUrl: string;

  /**
   * @generated from field: string section_content = 5;
   */
  sectionContent: string;
};

/**
 * @generated from message guardianai.v1.admin.BookSitelink
 */
export type BookSitelinkJson = {
  /**
   * @generated from field: string sitelink_text = 1;
   */
  sitelinkText?: string;

  /**
   * @generated from field: string description_1 = 2;
   */
  description1?: string;

  /**
   * @generated from field: string description_2 = 3;
   */
  description2?: string;

  /**
   * @generated from field: string final_url = 4;
   */
  finalUrl?: string;

  /**
   * @generated from field: string section_content = 5;
   */
  sectionContent?: string;
};

/**
 * Describes the message guardianai.v1.admin.BookSitelink.
 * Use `create(BookSitelinkSchema)` to create a new message.
 */
export const BookSitelinkSchema: GenMessage<BookSitelink, {jsonType: BookSitelinkJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_ad_funnel, 12);

/**
 * @generated from message guardianai.v1.admin.BookCompanionTool
 */
export type BookCompanionTool = Message<"guardianai.v1.admin.BookCompanionTool"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string description = 2;
   */
  description: string;

  /**
   * @generated from field: string category = 3;
   */
  category: string;

  /**
   * @generated from field: string screenshot_url = 4;
   */
  screenshotUrl: string;

  /**
   * @generated from field: string destination_url = 5;
   */
  destinationUrl: string;

  /**
   * @generated from field: string availability_status = 6;
   */
  availabilityStatus: string;

  /**
   * Free, Paid, Coming Soon
   *
   * @generated from field: string classification = 7;
   */
  classification: string;

  /**
   * @generated from field: string cta_label = 8;
   */
  ctaLabel: string;
};

/**
 * @generated from message guardianai.v1.admin.BookCompanionTool
 */
export type BookCompanionToolJson = {
  /**
   * @generated from field: string name = 1;
   */
  name?: string;

  /**
   * @generated from field: string description = 2;
   */
  description?: string;

  /**
   * @generated from field: string category = 3;
   */
  category?: string;

  /**
   * @generated from field: string screenshot_url = 4;
   */
  screenshotUrl?: string;

  /**
   * @generated from field: string destination_url = 5;
   */
  destinationUrl?: string;

  /**
   * @generated from field: string availability_status = 6;
   */
  availabilityStatus?: string;

  /**
   * Free, Paid, Coming Soon
   *
   * @generated from field: string classification = 7;
   */
  classification?: string;

  /**
   * @generated from field: string cta_label = 8;
   */
  ctaLabel?: string;
};

/**
 * Describes the message guardianai.v1.admin.BookCompanionTool.
 * Use `create(BookCompanionToolSchema)` to create a new message.
 */
export const BookCompanionToolSchema: GenMessage<BookCompanionTool, {jsonType: BookCompanionToolJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_ad_funnel, 13);

/**
 * @generated from message guardianai.v1.admin.Product
 */
export type Product = Message<"guardianai.v1.admin.Product"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * URL-safe identifier (e.g., "family-care")
   *
   * @generated from field: string slug = 2;
   */
  slug: string;

  /**
   * @generated from field: guardianai.v1.admin.ProductType product_type = 3;
   */
  productType: ProductType;

  /**
   * Product name
   *
   * @generated from field: string name = 4;
   */
  name: string;

  /**
   * Short one-liner
   *
   * @generated from field: string tagline = 5;
   */
  tagline: string;

  /**
   * Rich markdown description
   *
   * @generated from field: string description = 6;
   */
  description: string;

  /**
   * Meta description
   *
   * @generated from field: string short_description = 7;
   */
  shortDescription: string;

  /**
   * Hero image / logo / icon
   *
   * @generated from field: string primary_image_url = 8;
   */
  primaryImageUrl: string;

  /**
   * Social sharing image
   *
   * @generated from field: string og_image_url = 9;
   */
  ogImageUrl: string;

  /**
   * "Start Free Trial", "Install App", etc.
   *
   * @generated from field: string primary_cta_label = 10;
   */
  primaryCtaLabel: string;

  /**
   * Where the main CTA leads
   *
   * @generated from field: string primary_cta_url = 11;
   */
  primaryCtaUrl: string;

  /**
   * DRAFT, PUBLISHED, ARCHIVED
   *
   * @generated from field: string status = 12;
   */
  status: string;

  /**
   * @generated from field: string created_by = 13;
   */
  createdBy: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 14;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 15;
   */
  updatedAt?: Timestamp;

  /**
   * Sub-collections
   *
   * @generated from field: repeated guardianai.v1.admin.ProductFeature features = 16;
   */
  features: ProductFeature[];

  /**
   * @generated from field: repeated guardianai.v1.admin.ProductTestimonial testimonials = 17;
   */
  testimonials: ProductTestimonial[];

  /**
   * @generated from field: repeated guardianai.v1.admin.ProductFAQ faqs = 18;
   */
  faqs: ProductFAQ[];

  /**
   * @generated from field: repeated guardianai.v1.admin.ProductDistribution distributions = 19;
   */
  distributions: ProductDistribution[];

  /**
   * @generated from field: repeated guardianai.v1.admin.ProductScreenshot screenshots = 20;
   */
  screenshots: ProductScreenshot[];

  /**
   * Type-specific JSON metadata blob
   *
   * @generated from field: string metadata_json = 21;
   */
  metadataJson: string;

  /**
   * SEO & Ad Tracking
   *
   * @generated from field: guardianai.v1.admin.ProductSeoControls seo = 22;
   */
  seo?: ProductSeoControls;

  /**
   * @generated from field: string google_ads_conversion_id = 23;
   */
  googleAdsConversionId: string;

  /**
   * @generated from field: string google_ads_conversion_label = 24;
   */
  googleAdsConversionLabel: string;
};

/**
 * @generated from message guardianai.v1.admin.Product
 */
export type ProductJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;

  /**
   * URL-safe identifier (e.g., "family-care")
   *
   * @generated from field: string slug = 2;
   */
  slug?: string;

  /**
   * @generated from field: guardianai.v1.admin.ProductType product_type = 3;
   */
  productType?: ProductTypeJson;

  /**
   * Product name
   *
   * @generated from field: string name = 4;
   */
  name?: string;

  /**
   * Short one-liner
   *
   * @generated from field: string tagline = 5;
   */
  tagline?: string;

  /**
   * Rich markdown description
   *
   * @generated from field: string description = 6;
   */
  description?: string;

  /**
   * Meta description
   *
   * @generated from field: string short_description = 7;
   */
  shortDescription?: string;

  /**
   * Hero image / logo / icon
   *
   * @generated from field: string primary_image_url = 8;
   */
  primaryImageUrl?: string;

  /**
   * Social sharing image
   *
   * @generated from field: string og_image_url = 9;
   */
  ogImageUrl?: string;

  /**
   * "Start Free Trial", "Install App", etc.
   *
   * @generated from field: string primary_cta_label = 10;
   */
  primaryCtaLabel?: string;

  /**
   * Where the main CTA leads
   *
   * @generated from field: string primary_cta_url = 11;
   */
  primaryCtaUrl?: string;

  /**
   * DRAFT, PUBLISHED, ARCHIVED
   *
   * @generated from field: string status = 12;
   */
  status?: string;

  /**
   * @generated from field: string created_by = 13;
   */
  createdBy?: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 14;
   */
  createdAt?: TimestampJson;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 15;
   */
  updatedAt?: TimestampJson;

  /**
   * Sub-collections
   *
   * @generated from field: repeated guardianai.v1.admin.ProductFeature features = 16;
   */
  features?: ProductFeatureJson[];

  /**
   * @generated from field: repeated guardianai.v1.admin.ProductTestimonial testimonials = 17;
   */
  testimonials?: ProductTestimonialJson[];

  /**
   * @generated from field: repeated guardianai.v1.admin.ProductFAQ faqs = 18;
   */
  faqs?: ProductFAQJson[];

  /**
   * @generated from field: repeated guardianai.v1.admin.ProductDistribution distributions = 19;
   */
  distributions?: ProductDistributionJson[];

  /**
   * @generated from field: repeated guardianai.v1.admin.ProductScreenshot screenshots = 20;
   */
  screenshots?: ProductScreenshotJson[];

  /**
   * Type-specific JSON metadata blob
   *
   * @generated from field: string metadata_json = 21;
   */
  metadataJson?: string;

  /**
   * SEO & Ad Tracking
   *
   * @generated from field: guardianai.v1.admin.ProductSeoControls seo = 22;
   */
  seo?: ProductSeoControlsJson;

  /**
   * @generated from field: string google_ads_conversion_id = 23;
   */
  googleAdsConversionId?: string;

  /**
   * @generated from field: string google_ads_conversion_label = 24;
   */
  googleAdsConversionLabel?: string;
};

/**
 * Describes the message guardianai.v1.admin.Product.
 * Use `create(ProductSchema)` to create a new message.
 */
export const ProductSchema: GenMessage<Product, {jsonType: ProductJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_ad_funnel, 14);

/**
 * @generated from message guardianai.v1.admin.ProductFeature
 */
export type ProductFeature = Message<"guardianai.v1.admin.ProductFeature"> & {
  /**
   * @generated from field: string title = 1;
   */
  title: string;

  /**
   * @generated from field: string description = 2;
   */
  description: string;

  /**
   * MUI icon name or icon key
   *
   * @generated from field: string icon_name = 3;
   */
  iconName: string;

  /**
   * @generated from field: int32 display_order = 4;
   */
  displayOrder: number;
};

/**
 * @generated from message guardianai.v1.admin.ProductFeature
 */
export type ProductFeatureJson = {
  /**
   * @generated from field: string title = 1;
   */
  title?: string;

  /**
   * @generated from field: string description = 2;
   */
  description?: string;

  /**
   * MUI icon name or icon key
   *
   * @generated from field: string icon_name = 3;
   */
  iconName?: string;

  /**
   * @generated from field: int32 display_order = 4;
   */
  displayOrder?: number;
};

/**
 * Describes the message guardianai.v1.admin.ProductFeature.
 * Use `create(ProductFeatureSchema)` to create a new message.
 */
export const ProductFeatureSchema: GenMessage<ProductFeature, {jsonType: ProductFeatureJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_ad_funnel, 15);

/**
 * @generated from message guardianai.v1.admin.ProductTestimonial
 */
export type ProductTestimonial = Message<"guardianai.v1.admin.ProductTestimonial"> & {
  /**
   * @generated from field: string reviewer_name = 1;
   */
  reviewerName: string;

  /**
   * @generated from field: string reviewer_role = 2;
   */
  reviewerRole: string;

  /**
   * @generated from field: string review_text = 3;
   */
  reviewText: string;

  /**
   * 1-5 star rating
   *
   * @generated from field: int32 rating = 4;
   */
  rating: number;

  /**
   * @generated from field: bool verified = 5;
   */
  verified: boolean;

  /**
   * @generated from field: int32 display_order = 6;
   */
  displayOrder: number;
};

/**
 * @generated from message guardianai.v1.admin.ProductTestimonial
 */
export type ProductTestimonialJson = {
  /**
   * @generated from field: string reviewer_name = 1;
   */
  reviewerName?: string;

  /**
   * @generated from field: string reviewer_role = 2;
   */
  reviewerRole?: string;

  /**
   * @generated from field: string review_text = 3;
   */
  reviewText?: string;

  /**
   * 1-5 star rating
   *
   * @generated from field: int32 rating = 4;
   */
  rating?: number;

  /**
   * @generated from field: bool verified = 5;
   */
  verified?: boolean;

  /**
   * @generated from field: int32 display_order = 6;
   */
  displayOrder?: number;
};

/**
 * Describes the message guardianai.v1.admin.ProductTestimonial.
 * Use `create(ProductTestimonialSchema)` to create a new message.
 */
export const ProductTestimonialSchema: GenMessage<ProductTestimonial, {jsonType: ProductTestimonialJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_ad_funnel, 16);

/**
 * @generated from message guardianai.v1.admin.ProductFAQ
 */
export type ProductFAQ = Message<"guardianai.v1.admin.ProductFAQ"> & {
  /**
   * @generated from field: string question = 1;
   */
  question: string;

  /**
   * @generated from field: string answer = 2;
   */
  answer: string;

  /**
   * @generated from field: int32 display_order = 3;
   */
  displayOrder: number;
};

/**
 * @generated from message guardianai.v1.admin.ProductFAQ
 */
export type ProductFAQJson = {
  /**
   * @generated from field: string question = 1;
   */
  question?: string;

  /**
   * @generated from field: string answer = 2;
   */
  answer?: string;

  /**
   * @generated from field: int32 display_order = 3;
   */
  displayOrder?: number;
};

/**
 * Describes the message guardianai.v1.admin.ProductFAQ.
 * Use `create(ProductFAQSchema)` to create a new message.
 */
export const ProductFAQSchema: GenMessage<ProductFAQ, {jsonType: ProductFAQJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_ad_funnel, 17);

/**
 * @generated from message guardianai.v1.admin.ProductDistribution
 */
export type ProductDistribution = Message<"guardianai.v1.admin.ProductDistribution"> & {
  /**
   * "Wix Marketplace", "Shopify Store", "Apple App Store", "Google Play", "Platform Internal"
   *
   * @generated from field: string platform = 1;
   */
  platform: string;

  /**
   * Link to listing / install page
   *
   * @generated from field: string destination_url = 2;
   */
  destinationUrl: string;

  /**
   * Badge image URL
   *
   * @generated from field: string badge_image_url = 3;
   */
  badgeImageUrl: string;

  /**
   * "Free", "$9.99/mo", "$4.99"
   *
   * @generated from field: string display_price = 4;
   */
  displayPrice: string;

  /**
   * @generated from field: string currency = 5;
   */
  currency: string;

  /**
   * "Install App", "Download on App Store", "Subscribe"
   *
   * @generated from field: string button_label = 6;
   */
  buttonLabel: string;

  /**
   * @generated from field: bool active = 7;
   */
  active: boolean;

  /**
   * @generated from field: int32 display_order = 8;
   */
  displayOrder: number;

  /**
   * @generated from field: double conversion_value = 9;
   */
  conversionValue: number;
};

/**
 * @generated from message guardianai.v1.admin.ProductDistribution
 */
export type ProductDistributionJson = {
  /**
   * "Wix Marketplace", "Shopify Store", "Apple App Store", "Google Play", "Platform Internal"
   *
   * @generated from field: string platform = 1;
   */
  platform?: string;

  /**
   * Link to listing / install page
   *
   * @generated from field: string destination_url = 2;
   */
  destinationUrl?: string;

  /**
   * Badge image URL
   *
   * @generated from field: string badge_image_url = 3;
   */
  badgeImageUrl?: string;

  /**
   * "Free", "$9.99/mo", "$4.99"
   *
   * @generated from field: string display_price = 4;
   */
  displayPrice?: string;

  /**
   * @generated from field: string currency = 5;
   */
  currency?: string;

  /**
   * "Install App", "Download on App Store", "Subscribe"
   *
   * @generated from field: string button_label = 6;
   */
  buttonLabel?: string;

  /**
   * @generated from field: bool active = 7;
   */
  active?: boolean;

  /**
   * @generated from field: int32 display_order = 8;
   */
  displayOrder?: number;

  /**
   * @generated from field: double conversion_value = 9;
   */
  conversionValue?: number | "NaN" | "Infinity" | "-Infinity";
};

/**
 * Describes the message guardianai.v1.admin.ProductDistribution.
 * Use `create(ProductDistributionSchema)` to create a new message.
 */
export const ProductDistributionSchema: GenMessage<ProductDistribution, {jsonType: ProductDistributionJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_ad_funnel, 18);

/**
 * @generated from message guardianai.v1.admin.ProductScreenshot
 */
export type ProductScreenshot = Message<"guardianai.v1.admin.ProductScreenshot"> & {
  /**
   * @generated from field: string image_url = 1;
   */
  imageUrl: string;

  /**
   * @generated from field: string caption = 2;
   */
  caption: string;

  /**
   * @generated from field: int32 display_order = 3;
   */
  displayOrder: number;
};

/**
 * @generated from message guardianai.v1.admin.ProductScreenshot
 */
export type ProductScreenshotJson = {
  /**
   * @generated from field: string image_url = 1;
   */
  imageUrl?: string;

  /**
   * @generated from field: string caption = 2;
   */
  caption?: string;

  /**
   * @generated from field: int32 display_order = 3;
   */
  displayOrder?: number;
};

/**
 * Describes the message guardianai.v1.admin.ProductScreenshot.
 * Use `create(ProductScreenshotSchema)` to create a new message.
 */
export const ProductScreenshotSchema: GenMessage<ProductScreenshot, {jsonType: ProductScreenshotJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_ad_funnel, 19);

/**
 * @generated from message guardianai.v1.admin.ProductSeoControls
 */
export type ProductSeoControls = Message<"guardianai.v1.admin.ProductSeoControls"> & {
  /**
   * @generated from field: string seo_title = 1;
   */
  seoTitle: string;

  /**
   * @generated from field: string meta_description = 2;
   */
  metaDescription: string;

  /**
   * @generated from field: string canonical_url = 3;
   */
  canonicalUrl: string;

  /**
   * @generated from field: string og_title = 4;
   */
  ogTitle: string;

  /**
   * @generated from field: string og_description = 5;
   */
  ogDescription: string;

  /**
   * @generated from field: string og_image = 6;
   */
  ogImage: string;

  /**
   * @generated from field: bool index = 7;
   */
  index: boolean;

  /**
   * @generated from field: bool follow = 8;
   */
  follow: boolean;
};

/**
 * @generated from message guardianai.v1.admin.ProductSeoControls
 */
export type ProductSeoControlsJson = {
  /**
   * @generated from field: string seo_title = 1;
   */
  seoTitle?: string;

  /**
   * @generated from field: string meta_description = 2;
   */
  metaDescription?: string;

  /**
   * @generated from field: string canonical_url = 3;
   */
  canonicalUrl?: string;

  /**
   * @generated from field: string og_title = 4;
   */
  ogTitle?: string;

  /**
   * @generated from field: string og_description = 5;
   */
  ogDescription?: string;

  /**
   * @generated from field: string og_image = 6;
   */
  ogImage?: string;

  /**
   * @generated from field: bool index = 7;
   */
  index?: boolean;

  /**
   * @generated from field: bool follow = 8;
   */
  follow?: boolean;
};

/**
 * Describes the message guardianai.v1.admin.ProductSeoControls.
 * Use `create(ProductSeoControlsSchema)` to create a new message.
 */
export const ProductSeoControlsSchema: GenMessage<ProductSeoControls, {jsonType: ProductSeoControlsJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_ad_funnel, 20);

/**
 * Structured configuration only. api_secret is write-only and is always empty in responses.
 *
 * @generated from message guardianai.v1.admin.AdvertisingEventMapping
 */
export type AdvertisingEventMapping = Message<"guardianai.v1.admin.AdvertisingEventMapping"> & {
  /**
   * @generated from field: guardianai.v1.admin.CanonicalAdvertisingEventType canonical_event = 1;
   */
  canonicalEvent: CanonicalAdvertisingEventType;

  /**
   * @generated from field: bool enabled = 2;
   */
  enabled: boolean;

  /**
   * STANDARD or CUSTOM
   *
   * @generated from field: string provider_event_type = 3;
   */
  providerEventType: string;

  /**
   * @generated from field: string provider_event_name = 4;
   */
  providerEventName: string;

  /**
   * @generated from field: string event_category = 5;
   */
  eventCategory: string;

  /**
   * @generated from field: string event_label = 6;
   */
  eventLabel: string;

  /**
   * @generated from field: double value = 7;
   */
  value: number;

  /**
   * @generated from field: string currency = 8;
   */
  currency: string;
};

/**
 * Structured configuration only. api_secret is write-only and is always empty in responses.
 *
 * @generated from message guardianai.v1.admin.AdvertisingEventMapping
 */
export type AdvertisingEventMappingJson = {
  /**
   * @generated from field: guardianai.v1.admin.CanonicalAdvertisingEventType canonical_event = 1;
   */
  canonicalEvent?: CanonicalAdvertisingEventTypeJson;

  /**
   * @generated from field: bool enabled = 2;
   */
  enabled?: boolean;

  /**
   * STANDARD or CUSTOM
   *
   * @generated from field: string provider_event_type = 3;
   */
  providerEventType?: string;

  /**
   * @generated from field: string provider_event_name = 4;
   */
  providerEventName?: string;

  /**
   * @generated from field: string event_category = 5;
   */
  eventCategory?: string;

  /**
   * @generated from field: string event_label = 6;
   */
  eventLabel?: string;

  /**
   * @generated from field: double value = 7;
   */
  value?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: string currency = 8;
   */
  currency?: string;
};

/**
 * Describes the message guardianai.v1.admin.AdvertisingEventMapping.
 * Use `create(AdvertisingEventMappingSchema)` to create a new message.
 */
export const AdvertisingEventMappingSchema: GenMessage<AdvertisingEventMapping, {jsonType: AdvertisingEventMappingJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_ad_funnel, 21);

/**
 * @generated from message guardianai.v1.admin.AdvertisingProviderConfig
 */
export type AdvertisingProviderConfig = Message<"guardianai.v1.admin.AdvertisingProviderConfig"> & {
  /**
   * @generated from field: guardianai.v1.admin.AdvertisingProvider provider = 1;
   */
  provider: AdvertisingProvider;

  /**
   * @generated from field: bool enabled = 2;
   */
  enabled: boolean;

  /**
   * @generated from field: guardianai.v1.admin.AdvertisingTrackingMode tracking_mode = 3;
   */
  trackingMode: AdvertisingTrackingMode;

  /**
   * @generated from field: string public_tracker_id = 4;
   */
  publicTrackerId: string;

  /**
   * write-only; never returned
   *
   * @generated from field: string api_secret = 5;
   */
  apiSecret: string;

  /**
   * @generated from field: bool api_secret_configured = 6;
   */
  apiSecretConfigured: boolean;

  /**
   * @generated from field: int32 attribution_window_days = 7;
   */
  attributionWindowDays: number;

  /**
   * @generated from field: repeated guardianai.v1.admin.AdvertisingEventMapping event_mappings = 8;
   */
  eventMappings: AdvertisingEventMapping[];

  /**
   * admin responses only
   *
   * @generated from field: string campaign_destination_url = 9;
   */
  campaignDestinationUrl: string;
};

/**
 * @generated from message guardianai.v1.admin.AdvertisingProviderConfig
 */
export type AdvertisingProviderConfigJson = {
  /**
   * @generated from field: guardianai.v1.admin.AdvertisingProvider provider = 1;
   */
  provider?: AdvertisingProviderJson;

  /**
   * @generated from field: bool enabled = 2;
   */
  enabled?: boolean;

  /**
   * @generated from field: guardianai.v1.admin.AdvertisingTrackingMode tracking_mode = 3;
   */
  trackingMode?: AdvertisingTrackingModeJson;

  /**
   * @generated from field: string public_tracker_id = 4;
   */
  publicTrackerId?: string;

  /**
   * write-only; never returned
   *
   * @generated from field: string api_secret = 5;
   */
  apiSecret?: string;

  /**
   * @generated from field: bool api_secret_configured = 6;
   */
  apiSecretConfigured?: boolean;

  /**
   * @generated from field: int32 attribution_window_days = 7;
   */
  attributionWindowDays?: number;

  /**
   * @generated from field: repeated guardianai.v1.admin.AdvertisingEventMapping event_mappings = 8;
   */
  eventMappings?: AdvertisingEventMappingJson[];

  /**
   * admin responses only
   *
   * @generated from field: string campaign_destination_url = 9;
   */
  campaignDestinationUrl?: string;
};

/**
 * Describes the message guardianai.v1.admin.AdvertisingProviderConfig.
 * Use `create(AdvertisingProviderConfigSchema)` to create a new message.
 */
export const AdvertisingProviderConfigSchema: GenMessage<AdvertisingProviderConfig, {jsonType: AdvertisingProviderConfigJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_ad_funnel, 22);

/**
 * @generated from message guardianai.v1.admin.AdvertisingAcquisitionContext
 */
export type AdvertisingAcquisitionContext = Message<"guardianai.v1.admin.AdvertisingAcquisitionContext"> & {
  /**
   * @generated from field: string context_id = 1;
   */
  contextId: string;

  /**
   * @generated from field: guardianai.v1.admin.AdvertisingProvider provider = 2;
   */
  provider: AdvertisingProvider;

  /**
   * @generated from field: guardianai.v1.admin.AdvertisingAttributionConfidence confidence = 3;
   */
  confidence: AdvertisingAttributionConfidence;

  /**
   * @generated from field: google.protobuf.Timestamp acquired_at = 4;
   */
  acquiredAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp expires_at = 5;
   */
  expiresAt?: Timestamp;

  /**
   * @generated from field: string landing_page_kind = 6;
   */
  landingPageKind: string;

  /**
   * @generated from field: string landing_page_id = 7;
   */
  landingPageId: string;

  /**
   * @generated from field: string source_token_id = 8;
   */
  sourceTokenId: string;

  /**
   * @generated from field: string gclid = 9;
   */
  gclid: string;

  /**
   * @generated from field: string gbraid = 10;
   */
  gbraid: string;

  /**
   * @generated from field: string wbraid = 11;
   */
  wbraid: string;

  /**
   * @generated from field: string oppref = 12;
   */
  oppref: string;

  /**
   * @generated from field: string msclkid = 13;
   */
  msclkid: string;

  /**
   * @generated from field: string utm_source = 14;
   */
  utmSource: string;

  /**
   * @generated from field: string utm_medium = 15;
   */
  utmMedium: string;

  /**
   * @generated from field: string utm_campaign = 16;
   */
  utmCampaign: string;

  /**
   * @generated from field: string utm_content = 17;
   */
  utmContent: string;

  /**
   * @generated from field: string utm_term = 18;
   */
  utmTerm: string;

  /**
   * @generated from field: repeated string evidence = 19;
   */
  evidence: string[];
};

/**
 * @generated from message guardianai.v1.admin.AdvertisingAcquisitionContext
 */
export type AdvertisingAcquisitionContextJson = {
  /**
   * @generated from field: string context_id = 1;
   */
  contextId?: string;

  /**
   * @generated from field: guardianai.v1.admin.AdvertisingProvider provider = 2;
   */
  provider?: AdvertisingProviderJson;

  /**
   * @generated from field: guardianai.v1.admin.AdvertisingAttributionConfidence confidence = 3;
   */
  confidence?: AdvertisingAttributionConfidenceJson;

  /**
   * @generated from field: google.protobuf.Timestamp acquired_at = 4;
   */
  acquiredAt?: TimestampJson;

  /**
   * @generated from field: google.protobuf.Timestamp expires_at = 5;
   */
  expiresAt?: TimestampJson;

  /**
   * @generated from field: string landing_page_kind = 6;
   */
  landingPageKind?: string;

  /**
   * @generated from field: string landing_page_id = 7;
   */
  landingPageId?: string;

  /**
   * @generated from field: string source_token_id = 8;
   */
  sourceTokenId?: string;

  /**
   * @generated from field: string gclid = 9;
   */
  gclid?: string;

  /**
   * @generated from field: string gbraid = 10;
   */
  gbraid?: string;

  /**
   * @generated from field: string wbraid = 11;
   */
  wbraid?: string;

  /**
   * @generated from field: string oppref = 12;
   */
  oppref?: string;

  /**
   * @generated from field: string msclkid = 13;
   */
  msclkid?: string;

  /**
   * @generated from field: string utm_source = 14;
   */
  utmSource?: string;

  /**
   * @generated from field: string utm_medium = 15;
   */
  utmMedium?: string;

  /**
   * @generated from field: string utm_campaign = 16;
   */
  utmCampaign?: string;

  /**
   * @generated from field: string utm_content = 17;
   */
  utmContent?: string;

  /**
   * @generated from field: string utm_term = 18;
   */
  utmTerm?: string;

  /**
   * @generated from field: repeated string evidence = 19;
   */
  evidence?: string[];
};

/**
 * Describes the message guardianai.v1.admin.AdvertisingAcquisitionContext.
 * Use `create(AdvertisingAcquisitionContextSchema)` to create a new message.
 */
export const AdvertisingAcquisitionContextSchema: GenMessage<AdvertisingAcquisitionContext, {jsonType: AdvertisingAcquisitionContextJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_ad_funnel, 23);

/**
 * @generated from message guardianai.v1.admin.CreateAdFunnelRequest
 */
export type CreateAdFunnelRequest = Message<"guardianai.v1.admin.CreateAdFunnelRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string youtube_video_id = 2;
   */
  youtubeVideoId: string;

  /**
   * @generated from field: string headline = 3;
   */
  headline: string;

  /**
   * @generated from field: string description = 4;
   */
  description: string;

  /**
   * e.g. "Watch Now"
   *
   * @generated from field: string cta_text = 5;
   */
  ctaText: string;

  /**
   * Optional, empty string if deriving from YT
   *
   * @generated from field: string thumbnail_url = 6;
   */
  thumbnailUrl: string;

  /**
   * @generated from field: guardianai.v1.admin.FunnelType funnel_type = 7;
   */
  funnelType: FunnelType;

  /**
   * @generated from field: guardianai.v1.admin.CampaignStatus status = 8;
   */
  status: CampaignStatus;

  /**
   * @generated from field: string book_id = 9;
   */
  bookId: string;

  /**
   * @generated from field: string slug = 10;
   */
  slug: string;

  /**
   * @generated from field: string source = 11;
   */
  source: string;

  /**
   * @generated from field: string medium = 12;
   */
  medium: string;

  /**
   * @generated from field: string campaign_code = 13;
   */
  campaignCode: string;

  /**
   * @generated from field: string content_code = 14;
   */
  contentCode: string;

  /**
   * @generated from field: string term = 15;
   */
  term: string;

  /**
   * @generated from field: google.protobuf.Timestamp start_at = 16;
   */
  startAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp end_at = 17;
   */
  endAt?: Timestamp;

  /**
   * @generated from field: string geo_target = 18;
   */
  geoTarget: string;

  /**
   * @generated from field: string notes = 19;
   */
  notes: string;

  /**
   * @generated from field: string product_id = 20;
   */
  productId: string;
};

/**
 * @generated from message guardianai.v1.admin.CreateAdFunnelRequest
 */
export type CreateAdFunnelRequestJson = {
  /**
   * @generated from field: string name = 1;
   */
  name?: string;

  /**
   * @generated from field: string youtube_video_id = 2;
   */
  youtubeVideoId?: string;

  /**
   * @generated from field: string headline = 3;
   */
  headline?: string;

  /**
   * @generated from field: string description = 4;
   */
  description?: string;

  /**
   * e.g. "Watch Now"
   *
   * @generated from field: string cta_text = 5;
   */
  ctaText?: string;

  /**
   * Optional, empty string if deriving from YT
   *
   * @generated from field: string thumbnail_url = 6;
   */
  thumbnailUrl?: string;

  /**
   * @generated from field: guardianai.v1.admin.FunnelType funnel_type = 7;
   */
  funnelType?: FunnelTypeJson;

  /**
   * @generated from field: guardianai.v1.admin.CampaignStatus status = 8;
   */
  status?: CampaignStatusJson;

  /**
   * @generated from field: string book_id = 9;
   */
  bookId?: string;

  /**
   * @generated from field: string slug = 10;
   */
  slug?: string;

  /**
   * @generated from field: string source = 11;
   */
  source?: string;

  /**
   * @generated from field: string medium = 12;
   */
  medium?: string;

  /**
   * @generated from field: string campaign_code = 13;
   */
  campaignCode?: string;

  /**
   * @generated from field: string content_code = 14;
   */
  contentCode?: string;

  /**
   * @generated from field: string term = 15;
   */
  term?: string;

  /**
   * @generated from field: google.protobuf.Timestamp start_at = 16;
   */
  startAt?: TimestampJson;

  /**
   * @generated from field: google.protobuf.Timestamp end_at = 17;
   */
  endAt?: TimestampJson;

  /**
   * @generated from field: string geo_target = 18;
   */
  geoTarget?: string;

  /**
   * @generated from field: string notes = 19;
   */
  notes?: string;

  /**
   * @generated from field: string product_id = 20;
   */
  productId?: string;
};

/**
 * Describes the message guardianai.v1.admin.CreateAdFunnelRequest.
 * Use `create(CreateAdFunnelRequestSchema)` to create a new message.
 */
export const CreateAdFunnelRequestSchema: GenMessage<CreateAdFunnelRequest, {jsonType: CreateAdFunnelRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_ad_funnel, 24);

/**
 * Can expand with pagination later
 *
 * @generated from message guardianai.v1.admin.ListAdFunnelsRequest
 */
export type ListAdFunnelsRequest = Message<"guardianai.v1.admin.ListAdFunnelsRequest"> & {
};

/**
 * Can expand with pagination later
 *
 * @generated from message guardianai.v1.admin.ListAdFunnelsRequest
 */
export type ListAdFunnelsRequestJson = {
};

/**
 * Describes the message guardianai.v1.admin.ListAdFunnelsRequest.
 * Use `create(ListAdFunnelsRequestSchema)` to create a new message.
 */
export const ListAdFunnelsRequestSchema: GenMessage<ListAdFunnelsRequest, {jsonType: ListAdFunnelsRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_ad_funnel, 25);

/**
 * @generated from message guardianai.v1.admin.ListAdFunnelsResponse
 */
export type ListAdFunnelsResponse = Message<"guardianai.v1.admin.ListAdFunnelsResponse"> & {
  /**
   * @generated from field: repeated guardianai.v1.admin.AdFunnel funnels = 1;
   */
  funnels: AdFunnel[];
};

/**
 * @generated from message guardianai.v1.admin.ListAdFunnelsResponse
 */
export type ListAdFunnelsResponseJson = {
  /**
   * @generated from field: repeated guardianai.v1.admin.AdFunnel funnels = 1;
   */
  funnels?: AdFunnelJson[];
};

/**
 * Describes the message guardianai.v1.admin.ListAdFunnelsResponse.
 * Use `create(ListAdFunnelsResponseSchema)` to create a new message.
 */
export const ListAdFunnelsResponseSchema: GenMessage<ListAdFunnelsResponse, {jsonType: ListAdFunnelsResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_ad_funnel, 26);

/**
 * @generated from message guardianai.v1.admin.GetAdFunnelRequest
 */
export type GetAdFunnelRequest = Message<"guardianai.v1.admin.GetAdFunnelRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * @generated from message guardianai.v1.admin.GetAdFunnelRequest
 */
export type GetAdFunnelRequestJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;
};

/**
 * Describes the message guardianai.v1.admin.GetAdFunnelRequest.
 * Use `create(GetAdFunnelRequestSchema)` to create a new message.
 */
export const GetAdFunnelRequestSchema: GenMessage<GetAdFunnelRequest, {jsonType: GetAdFunnelRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_ad_funnel, 27);

/**
 * @generated from message guardianai.v1.admin.GetAdFunnelResponse
 */
export type GetAdFunnelResponse = Message<"guardianai.v1.admin.GetAdFunnelResponse"> & {
  /**
   * @generated from field: guardianai.v1.admin.AdFunnel funnel = 1;
   */
  funnel?: AdFunnel;
};

/**
 * @generated from message guardianai.v1.admin.GetAdFunnelResponse
 */
export type GetAdFunnelResponseJson = {
  /**
   * @generated from field: guardianai.v1.admin.AdFunnel funnel = 1;
   */
  funnel?: AdFunnelJson;
};

/**
 * Describes the message guardianai.v1.admin.GetAdFunnelResponse.
 * Use `create(GetAdFunnelResponseSchema)` to create a new message.
 */
export const GetAdFunnelResponseSchema: GenMessage<GetAdFunnelResponse, {jsonType: GetAdFunnelResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_ad_funnel, 28);

/**
 * @generated from message guardianai.v1.admin.UpdateAdFunnelRequest
 */
export type UpdateAdFunnelRequest = Message<"guardianai.v1.admin.UpdateAdFunnelRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string youtube_video_id = 3;
   */
  youtubeVideoId: string;

  /**
   * @generated from field: string headline = 4;
   */
  headline: string;

  /**
   * @generated from field: string description = 5;
   */
  description: string;

  /**
   * @generated from field: string cta_text = 6;
   */
  ctaText: string;

  /**
   * @generated from field: string thumbnail_url = 7;
   */
  thumbnailUrl: string;

  /**
   * @generated from field: bool is_active = 8;
   */
  isActive: boolean;

  /**
   * @generated from field: guardianai.v1.admin.FunnelType funnel_type = 9;
   */
  funnelType: FunnelType;

  /**
   * @generated from field: guardianai.v1.admin.CampaignStatus status = 10;
   */
  status: CampaignStatus;

  /**
   * @generated from field: string book_id = 11;
   */
  bookId: string;

  /**
   * @generated from field: string slug = 12;
   */
  slug: string;

  /**
   * @generated from field: string source = 13;
   */
  source: string;

  /**
   * @generated from field: string medium = 14;
   */
  medium: string;

  /**
   * @generated from field: string campaign_code = 15;
   */
  campaignCode: string;

  /**
   * @generated from field: string content_code = 16;
   */
  contentCode: string;

  /**
   * @generated from field: string term = 17;
   */
  term: string;

  /**
   * @generated from field: google.protobuf.Timestamp start_at = 18;
   */
  startAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp end_at = 19;
   */
  endAt?: Timestamp;

  /**
   * @generated from field: string geo_target = 20;
   */
  geoTarget: string;

  /**
   * @generated from field: string notes = 21;
   */
  notes: string;

  /**
   * @generated from field: string product_id = 22;
   */
  productId: string;
};

/**
 * @generated from message guardianai.v1.admin.UpdateAdFunnelRequest
 */
export type UpdateAdFunnelRequestJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;

  /**
   * @generated from field: string name = 2;
   */
  name?: string;

  /**
   * @generated from field: string youtube_video_id = 3;
   */
  youtubeVideoId?: string;

  /**
   * @generated from field: string headline = 4;
   */
  headline?: string;

  /**
   * @generated from field: string description = 5;
   */
  description?: string;

  /**
   * @generated from field: string cta_text = 6;
   */
  ctaText?: string;

  /**
   * @generated from field: string thumbnail_url = 7;
   */
  thumbnailUrl?: string;

  /**
   * @generated from field: bool is_active = 8;
   */
  isActive?: boolean;

  /**
   * @generated from field: guardianai.v1.admin.FunnelType funnel_type = 9;
   */
  funnelType?: FunnelTypeJson;

  /**
   * @generated from field: guardianai.v1.admin.CampaignStatus status = 10;
   */
  status?: CampaignStatusJson;

  /**
   * @generated from field: string book_id = 11;
   */
  bookId?: string;

  /**
   * @generated from field: string slug = 12;
   */
  slug?: string;

  /**
   * @generated from field: string source = 13;
   */
  source?: string;

  /**
   * @generated from field: string medium = 14;
   */
  medium?: string;

  /**
   * @generated from field: string campaign_code = 15;
   */
  campaignCode?: string;

  /**
   * @generated from field: string content_code = 16;
   */
  contentCode?: string;

  /**
   * @generated from field: string term = 17;
   */
  term?: string;

  /**
   * @generated from field: google.protobuf.Timestamp start_at = 18;
   */
  startAt?: TimestampJson;

  /**
   * @generated from field: google.protobuf.Timestamp end_at = 19;
   */
  endAt?: TimestampJson;

  /**
   * @generated from field: string geo_target = 20;
   */
  geoTarget?: string;

  /**
   * @generated from field: string notes = 21;
   */
  notes?: string;

  /**
   * @generated from field: string product_id = 22;
   */
  productId?: string;
};

/**
 * Describes the message guardianai.v1.admin.UpdateAdFunnelRequest.
 * Use `create(UpdateAdFunnelRequestSchema)` to create a new message.
 */
export const UpdateAdFunnelRequestSchema: GenMessage<UpdateAdFunnelRequest, {jsonType: UpdateAdFunnelRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_ad_funnel, 29);

/**
 * @generated from message guardianai.v1.admin.DeleteAdFunnelRequest
 */
export type DeleteAdFunnelRequest = Message<"guardianai.v1.admin.DeleteAdFunnelRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * @generated from message guardianai.v1.admin.DeleteAdFunnelRequest
 */
export type DeleteAdFunnelRequestJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;
};

/**
 * Describes the message guardianai.v1.admin.DeleteAdFunnelRequest.
 * Use `create(DeleteAdFunnelRequestSchema)` to create a new message.
 */
export const DeleteAdFunnelRequestSchema: GenMessage<DeleteAdFunnelRequest, {jsonType: DeleteAdFunnelRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_ad_funnel, 30);

/**
 * Intentionally empty
 *
 * @generated from message guardianai.v1.admin.DeleteAdFunnelResponse
 */
export type DeleteAdFunnelResponse = Message<"guardianai.v1.admin.DeleteAdFunnelResponse"> & {
};

/**
 * Intentionally empty
 *
 * @generated from message guardianai.v1.admin.DeleteAdFunnelResponse
 */
export type DeleteAdFunnelResponseJson = {
};

/**
 * Describes the message guardianai.v1.admin.DeleteAdFunnelResponse.
 * Use `create(DeleteAdFunnelResponseSchema)` to create a new message.
 */
export const DeleteAdFunnelResponseSchema: GenMessage<DeleteAdFunnelResponse, {jsonType: DeleteAdFunnelResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_ad_funnel, 31);

/**
 * @generated from message guardianai.v1.admin.TrackAdFunnelEventRequest
 */
export type TrackAdFunnelEventRequest = Message<"guardianai.v1.admin.TrackAdFunnelEventRequest"> & {
  /**
   * @generated from field: string funnel_id = 1;
   */
  funnelId: string;

  /**
   * "view", "click", "book_landing_view", etc.
   *
   * @generated from field: string event_type = 2;
   */
  eventType: string;

  /**
   * Optional anonymous session tracking
   *
   * @generated from field: string session_id = 3;
   */
  sessionId: string;

  /**
   * Extra tracking context:
   *
   * @generated from field: string book_id = 4;
   */
  bookId: string;

  /**
   * @generated from field: string offer_id = 5;
   */
  offerId: string;

  /**
   * @generated from field: string source = 6;
   */
  source: string;

  /**
   * @generated from field: string medium = 7;
   */
  medium: string;

  /**
   * @generated from field: string campaign_code = 8;
   */
  campaignCode: string;

  /**
   * @generated from field: string creative_code = 9;
   */
  creativeCode: string;

  /**
   * @generated from field: string term = 10;
   */
  term: string;

  /**
   * @generated from field: string marketplace = 11;
   */
  marketplace: string;

  /**
   * @generated from field: string format = 12;
   */
  format: string;

  /**
   * @generated from field: string referrer_domain = 13;
   */
  referrerDomain: string;

  /**
   * @generated from field: string device_category = 14;
   */
  deviceCategory: string;

  /**
   * @generated from field: string country_code = 15;
   */
  countryCode: string;

  /**
   * @generated from field: string variant_id = 16;
   */
  variantId: string;

  /**
   * @generated from field: string currency = 17;
   */
  currency: string;

  /**
   * @generated from field: string button_position = 18;
   */
  buttonPosition: string;

  /**
   * @generated from field: string product_id = 19;
   */
  productId: string;
};

/**
 * @generated from message guardianai.v1.admin.TrackAdFunnelEventRequest
 */
export type TrackAdFunnelEventRequestJson = {
  /**
   * @generated from field: string funnel_id = 1;
   */
  funnelId?: string;

  /**
   * "view", "click", "book_landing_view", etc.
   *
   * @generated from field: string event_type = 2;
   */
  eventType?: string;

  /**
   * Optional anonymous session tracking
   *
   * @generated from field: string session_id = 3;
   */
  sessionId?: string;

  /**
   * Extra tracking context:
   *
   * @generated from field: string book_id = 4;
   */
  bookId?: string;

  /**
   * @generated from field: string offer_id = 5;
   */
  offerId?: string;

  /**
   * @generated from field: string source = 6;
   */
  source?: string;

  /**
   * @generated from field: string medium = 7;
   */
  medium?: string;

  /**
   * @generated from field: string campaign_code = 8;
   */
  campaignCode?: string;

  /**
   * @generated from field: string creative_code = 9;
   */
  creativeCode?: string;

  /**
   * @generated from field: string term = 10;
   */
  term?: string;

  /**
   * @generated from field: string marketplace = 11;
   */
  marketplace?: string;

  /**
   * @generated from field: string format = 12;
   */
  format?: string;

  /**
   * @generated from field: string referrer_domain = 13;
   */
  referrerDomain?: string;

  /**
   * @generated from field: string device_category = 14;
   */
  deviceCategory?: string;

  /**
   * @generated from field: string country_code = 15;
   */
  countryCode?: string;

  /**
   * @generated from field: string variant_id = 16;
   */
  variantId?: string;

  /**
   * @generated from field: string currency = 17;
   */
  currency?: string;

  /**
   * @generated from field: string button_position = 18;
   */
  buttonPosition?: string;

  /**
   * @generated from field: string product_id = 19;
   */
  productId?: string;
};

/**
 * Describes the message guardianai.v1.admin.TrackAdFunnelEventRequest.
 * Use `create(TrackAdFunnelEventRequestSchema)` to create a new message.
 */
export const TrackAdFunnelEventRequestSchema: GenMessage<TrackAdFunnelEventRequest, {jsonType: TrackAdFunnelEventRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_ad_funnel, 32);

/**
 * Intentionally empty for 204 No Content equivalence
 *
 * @generated from message guardianai.v1.admin.TrackAdFunnelEventResponse
 */
export type TrackAdFunnelEventResponse = Message<"guardianai.v1.admin.TrackAdFunnelEventResponse"> & {
};

/**
 * Intentionally empty for 204 No Content equivalence
 *
 * @generated from message guardianai.v1.admin.TrackAdFunnelEventResponse
 */
export type TrackAdFunnelEventResponseJson = {
};

/**
 * Describes the message guardianai.v1.admin.TrackAdFunnelEventResponse.
 * Use `create(TrackAdFunnelEventResponseSchema)` to create a new message.
 */
export const TrackAdFunnelEventResponseSchema: GenMessage<TrackAdFunnelEventResponse, {jsonType: TrackAdFunnelEventResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_ad_funnel, 33);

/**
 * @generated from message guardianai.v1.admin.GetAdFunnelStatsRequest
 */
export type GetAdFunnelStatsRequest = Message<"guardianai.v1.admin.GetAdFunnelStatsRequest"> & {
  /**
   * @generated from field: string funnel_id = 1;
   */
  funnelId: string;
};

/**
 * @generated from message guardianai.v1.admin.GetAdFunnelStatsRequest
 */
export type GetAdFunnelStatsRequestJson = {
  /**
   * @generated from field: string funnel_id = 1;
   */
  funnelId?: string;
};

/**
 * Describes the message guardianai.v1.admin.GetAdFunnelStatsRequest.
 * Use `create(GetAdFunnelStatsRequestSchema)` to create a new message.
 */
export const GetAdFunnelStatsRequestSchema: GenMessage<GetAdFunnelStatsRequest, {jsonType: GetAdFunnelStatsRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_ad_funnel, 34);

/**
 * @generated from message guardianai.v1.admin.GetAdFunnelStatsResponse
 */
export type GetAdFunnelStatsResponse = Message<"guardianai.v1.admin.GetAdFunnelStatsResponse"> & {
  /**
   * @generated from field: string funnel_id = 1;
   */
  funnelId: string;

  /**
   * @generated from field: int64 total_views = 2;
   */
  totalViews: bigint;

  /**
   * @generated from field: int64 total_clicks = 3;
   */
  totalClicks: bigint;

  /**
   * @generated from field: map<string, int64> utm_sources = 4;
   */
  utmSources: { [key: string]: bigint };

  /**
   * @generated from field: map<string, int64> utm_mediums = 5;
   */
  utmMediums: { [key: string]: bigint };

  /**
   * @generated from field: map<string, int64> devices = 6;
   */
  devices: { [key: string]: bigint };

  /**
   * @generated from field: map<string, int64> formats = 7;
   */
  formats: { [key: string]: bigint };

  /**
   * @generated from field: map<string, int64> marketplaces = 8;
   */
  marketplaces: { [key: string]: bigint };

  /**
   * @generated from field: map<string, int64> countries = 9;
   */
  countries: { [key: string]: bigint };
};

/**
 * @generated from message guardianai.v1.admin.GetAdFunnelStatsResponse
 */
export type GetAdFunnelStatsResponseJson = {
  /**
   * @generated from field: string funnel_id = 1;
   */
  funnelId?: string;

  /**
   * @generated from field: int64 total_views = 2;
   */
  totalViews?: string;

  /**
   * @generated from field: int64 total_clicks = 3;
   */
  totalClicks?: string;

  /**
   * @generated from field: map<string, int64> utm_sources = 4;
   */
  utmSources?: { [key: string]: string };

  /**
   * @generated from field: map<string, int64> utm_mediums = 5;
   */
  utmMediums?: { [key: string]: string };

  /**
   * @generated from field: map<string, int64> devices = 6;
   */
  devices?: { [key: string]: string };

  /**
   * @generated from field: map<string, int64> formats = 7;
   */
  formats?: { [key: string]: string };

  /**
   * @generated from field: map<string, int64> marketplaces = 8;
   */
  marketplaces?: { [key: string]: string };

  /**
   * @generated from field: map<string, int64> countries = 9;
   */
  countries?: { [key: string]: string };
};

/**
 * Describes the message guardianai.v1.admin.GetAdFunnelStatsResponse.
 * Use `create(GetAdFunnelStatsResponseSchema)` to create a new message.
 */
export const GetAdFunnelStatsResponseSchema: GenMessage<GetAdFunnelStatsResponse, {jsonType: GetAdFunnelStatsResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_ad_funnel, 35);

/**
 * @generated from message guardianai.v1.admin.CreateBookRequest
 */
export type CreateBookRequest = Message<"guardianai.v1.admin.CreateBookRequest"> & {
  /**
   * @generated from field: guardianai.v1.admin.Book book = 1;
   */
  book?: Book;
};

/**
 * @generated from message guardianai.v1.admin.CreateBookRequest
 */
export type CreateBookRequestJson = {
  /**
   * @generated from field: guardianai.v1.admin.Book book = 1;
   */
  book?: BookJson;
};

/**
 * Describes the message guardianai.v1.admin.CreateBookRequest.
 * Use `create(CreateBookRequestSchema)` to create a new message.
 */
export const CreateBookRequestSchema: GenMessage<CreateBookRequest, {jsonType: CreateBookRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_ad_funnel, 36);

/**
 * @generated from message guardianai.v1.admin.UpdateBookRequest
 */
export type UpdateBookRequest = Message<"guardianai.v1.admin.UpdateBookRequest"> & {
  /**
   * @generated from field: guardianai.v1.admin.Book book = 1;
   */
  book?: Book;
};

/**
 * @generated from message guardianai.v1.admin.UpdateBookRequest
 */
export type UpdateBookRequestJson = {
  /**
   * @generated from field: guardianai.v1.admin.Book book = 1;
   */
  book?: BookJson;
};

/**
 * Describes the message guardianai.v1.admin.UpdateBookRequest.
 * Use `create(UpdateBookRequestSchema)` to create a new message.
 */
export const UpdateBookRequestSchema: GenMessage<UpdateBookRequest, {jsonType: UpdateBookRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_ad_funnel, 37);

/**
 * @generated from message guardianai.v1.admin.GetBookRequest
 */
export type GetBookRequest = Message<"guardianai.v1.admin.GetBookRequest"> & {
  /**
   * @generated from field: string id = 2;
   */
  id: string;

  /**
   * @generated from field: string slug = 3;
   */
  slug: string;
};

/**
 * @generated from message guardianai.v1.admin.GetBookRequest
 */
export type GetBookRequestJson = {
  /**
   * @generated from field: string id = 2;
   */
  id?: string;

  /**
   * @generated from field: string slug = 3;
   */
  slug?: string;
};

/**
 * Describes the message guardianai.v1.admin.GetBookRequest.
 * Use `create(GetBookRequestSchema)` to create a new message.
 */
export const GetBookRequestSchema: GenMessage<GetBookRequest, {jsonType: GetBookRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_ad_funnel, 38);

/**
 * @generated from message guardianai.v1.admin.GetBookResponse
 */
export type GetBookResponse = Message<"guardianai.v1.admin.GetBookResponse"> & {
  /**
   * @generated from field: guardianai.v1.admin.Book book = 1;
   */
  book?: Book;
};

/**
 * @generated from message guardianai.v1.admin.GetBookResponse
 */
export type GetBookResponseJson = {
  /**
   * @generated from field: guardianai.v1.admin.Book book = 1;
   */
  book?: BookJson;
};

/**
 * Describes the message guardianai.v1.admin.GetBookResponse.
 * Use `create(GetBookResponseSchema)` to create a new message.
 */
export const GetBookResponseSchema: GenMessage<GetBookResponse, {jsonType: GetBookResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_ad_funnel, 39);

/**
 * @generated from message guardianai.v1.admin.ListBooksRequest
 */
export type ListBooksRequest = Message<"guardianai.v1.admin.ListBooksRequest"> & {
};

/**
 * @generated from message guardianai.v1.admin.ListBooksRequest
 */
export type ListBooksRequestJson = {
};

/**
 * Describes the message guardianai.v1.admin.ListBooksRequest.
 * Use `create(ListBooksRequestSchema)` to create a new message.
 */
export const ListBooksRequestSchema: GenMessage<ListBooksRequest, {jsonType: ListBooksRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_ad_funnel, 40);

/**
 * @generated from message guardianai.v1.admin.ListBooksResponse
 */
export type ListBooksResponse = Message<"guardianai.v1.admin.ListBooksResponse"> & {
  /**
   * @generated from field: repeated guardianai.v1.admin.Book books = 1;
   */
  books: Book[];
};

/**
 * @generated from message guardianai.v1.admin.ListBooksResponse
 */
export type ListBooksResponseJson = {
  /**
   * @generated from field: repeated guardianai.v1.admin.Book books = 1;
   */
  books?: BookJson[];
};

/**
 * Describes the message guardianai.v1.admin.ListBooksResponse.
 * Use `create(ListBooksResponseSchema)` to create a new message.
 */
export const ListBooksResponseSchema: GenMessage<ListBooksResponse, {jsonType: ListBooksResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_ad_funnel, 41);

/**
 * @generated from message guardianai.v1.admin.DeleteBookRequest
 */
export type DeleteBookRequest = Message<"guardianai.v1.admin.DeleteBookRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * @generated from message guardianai.v1.admin.DeleteBookRequest
 */
export type DeleteBookRequestJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;
};

/**
 * Describes the message guardianai.v1.admin.DeleteBookRequest.
 * Use `create(DeleteBookRequestSchema)` to create a new message.
 */
export const DeleteBookRequestSchema: GenMessage<DeleteBookRequest, {jsonType: DeleteBookRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_ad_funnel, 42);

/**
 * @generated from message guardianai.v1.admin.DeleteBookResponse
 */
export type DeleteBookResponse = Message<"guardianai.v1.admin.DeleteBookResponse"> & {
};

/**
 * @generated from message guardianai.v1.admin.DeleteBookResponse
 */
export type DeleteBookResponseJson = {
};

/**
 * Describes the message guardianai.v1.admin.DeleteBookResponse.
 * Use `create(DeleteBookResponseSchema)` to create a new message.
 */
export const DeleteBookResponseSchema: GenMessage<DeleteBookResponse, {jsonType: DeleteBookResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_ad_funnel, 43);

/**
 * @generated from message guardianai.v1.admin.CreateProductRequest
 */
export type CreateProductRequest = Message<"guardianai.v1.admin.CreateProductRequest"> & {
  /**
   * @generated from field: guardianai.v1.admin.Product product = 1;
   */
  product?: Product;
};

/**
 * @generated from message guardianai.v1.admin.CreateProductRequest
 */
export type CreateProductRequestJson = {
  /**
   * @generated from field: guardianai.v1.admin.Product product = 1;
   */
  product?: ProductJson;
};

/**
 * Describes the message guardianai.v1.admin.CreateProductRequest.
 * Use `create(CreateProductRequestSchema)` to create a new message.
 */
export const CreateProductRequestSchema: GenMessage<CreateProductRequest, {jsonType: CreateProductRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_ad_funnel, 44);

/**
 * @generated from message guardianai.v1.admin.UpdateProductRequest
 */
export type UpdateProductRequest = Message<"guardianai.v1.admin.UpdateProductRequest"> & {
  /**
   * @generated from field: guardianai.v1.admin.Product product = 1;
   */
  product?: Product;
};

/**
 * @generated from message guardianai.v1.admin.UpdateProductRequest
 */
export type UpdateProductRequestJson = {
  /**
   * @generated from field: guardianai.v1.admin.Product product = 1;
   */
  product?: ProductJson;
};

/**
 * Describes the message guardianai.v1.admin.UpdateProductRequest.
 * Use `create(UpdateProductRequestSchema)` to create a new message.
 */
export const UpdateProductRequestSchema: GenMessage<UpdateProductRequest, {jsonType: UpdateProductRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_ad_funnel, 45);

/**
 * @generated from message guardianai.v1.admin.GetProductRequest
 */
export type GetProductRequest = Message<"guardianai.v1.admin.GetProductRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string slug = 2;
   */
  slug: string;
};

/**
 * @generated from message guardianai.v1.admin.GetProductRequest
 */
export type GetProductRequestJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;

  /**
   * @generated from field: string slug = 2;
   */
  slug?: string;
};

/**
 * Describes the message guardianai.v1.admin.GetProductRequest.
 * Use `create(GetProductRequestSchema)` to create a new message.
 */
export const GetProductRequestSchema: GenMessage<GetProductRequest, {jsonType: GetProductRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_ad_funnel, 46);

/**
 * @generated from message guardianai.v1.admin.GetProductResponse
 */
export type GetProductResponse = Message<"guardianai.v1.admin.GetProductResponse"> & {
  /**
   * @generated from field: guardianai.v1.admin.Product product = 1;
   */
  product?: Product;
};

/**
 * @generated from message guardianai.v1.admin.GetProductResponse
 */
export type GetProductResponseJson = {
  /**
   * @generated from field: guardianai.v1.admin.Product product = 1;
   */
  product?: ProductJson;
};

/**
 * Describes the message guardianai.v1.admin.GetProductResponse.
 * Use `create(GetProductResponseSchema)` to create a new message.
 */
export const GetProductResponseSchema: GenMessage<GetProductResponse, {jsonType: GetProductResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_ad_funnel, 47);

/**
 * @generated from message guardianai.v1.admin.ListProductsRequest
 */
export type ListProductsRequest = Message<"guardianai.v1.admin.ListProductsRequest"> & {
  /**
   * Optional filter (0 = all)
   *
   * @generated from field: guardianai.v1.admin.ProductType product_type = 1;
   */
  productType: ProductType;
};

/**
 * @generated from message guardianai.v1.admin.ListProductsRequest
 */
export type ListProductsRequestJson = {
  /**
   * Optional filter (0 = all)
   *
   * @generated from field: guardianai.v1.admin.ProductType product_type = 1;
   */
  productType?: ProductTypeJson;
};

/**
 * Describes the message guardianai.v1.admin.ListProductsRequest.
 * Use `create(ListProductsRequestSchema)` to create a new message.
 */
export const ListProductsRequestSchema: GenMessage<ListProductsRequest, {jsonType: ListProductsRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_ad_funnel, 48);

/**
 * @generated from message guardianai.v1.admin.ListProductsResponse
 */
export type ListProductsResponse = Message<"guardianai.v1.admin.ListProductsResponse"> & {
  /**
   * @generated from field: repeated guardianai.v1.admin.Product products = 1;
   */
  products: Product[];
};

/**
 * @generated from message guardianai.v1.admin.ListProductsResponse
 */
export type ListProductsResponseJson = {
  /**
   * @generated from field: repeated guardianai.v1.admin.Product products = 1;
   */
  products?: ProductJson[];
};

/**
 * Describes the message guardianai.v1.admin.ListProductsResponse.
 * Use `create(ListProductsResponseSchema)` to create a new message.
 */
export const ListProductsResponseSchema: GenMessage<ListProductsResponse, {jsonType: ListProductsResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_ad_funnel, 49);

/**
 * @generated from message guardianai.v1.admin.DeleteProductRequest
 */
export type DeleteProductRequest = Message<"guardianai.v1.admin.DeleteProductRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * @generated from message guardianai.v1.admin.DeleteProductRequest
 */
export type DeleteProductRequestJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;
};

/**
 * Describes the message guardianai.v1.admin.DeleteProductRequest.
 * Use `create(DeleteProductRequestSchema)` to create a new message.
 */
export const DeleteProductRequestSchema: GenMessage<DeleteProductRequest, {jsonType: DeleteProductRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_ad_funnel, 50);

/**
 * @generated from message guardianai.v1.admin.DeleteProductResponse
 */
export type DeleteProductResponse = Message<"guardianai.v1.admin.DeleteProductResponse"> & {
};

/**
 * @generated from message guardianai.v1.admin.DeleteProductResponse
 */
export type DeleteProductResponseJson = {
};

/**
 * Describes the message guardianai.v1.admin.DeleteProductResponse.
 * Use `create(DeleteProductResponseSchema)` to create a new message.
 */
export const DeleteProductResponseSchema: GenMessage<DeleteProductResponse, {jsonType: DeleteProductResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_ad_funnel, 51);

/**
 * @generated from message guardianai.v1.admin.GetAdvertisingTrackingConfigRequest
 */
export type GetAdvertisingTrackingConfigRequest = Message<"guardianai.v1.admin.GetAdvertisingTrackingConfigRequest"> & {
  /**
   * BOOK or PRODUCT
   *
   * @generated from field: string landing_page_kind = 1;
   */
  landingPageKind: string;

  /**
   * @generated from field: string landing_page_id = 2;
   */
  landingPageId: string;

  /**
   * @generated from field: string landing_page_url = 3;
   */
  landingPageUrl: string;
};

/**
 * @generated from message guardianai.v1.admin.GetAdvertisingTrackingConfigRequest
 */
export type GetAdvertisingTrackingConfigRequestJson = {
  /**
   * BOOK or PRODUCT
   *
   * @generated from field: string landing_page_kind = 1;
   */
  landingPageKind?: string;

  /**
   * @generated from field: string landing_page_id = 2;
   */
  landingPageId?: string;

  /**
   * @generated from field: string landing_page_url = 3;
   */
  landingPageUrl?: string;
};

/**
 * Describes the message guardianai.v1.admin.GetAdvertisingTrackingConfigRequest.
 * Use `create(GetAdvertisingTrackingConfigRequestSchema)` to create a new message.
 */
export const GetAdvertisingTrackingConfigRequestSchema: GenMessage<GetAdvertisingTrackingConfigRequest, {jsonType: GetAdvertisingTrackingConfigRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_ad_funnel, 52);

/**
 * @generated from message guardianai.v1.admin.GetAdvertisingTrackingConfigResponse
 */
export type GetAdvertisingTrackingConfigResponse = Message<"guardianai.v1.admin.GetAdvertisingTrackingConfigResponse"> & {
  /**
   * @generated from field: repeated guardianai.v1.admin.AdvertisingProviderConfig providers = 1;
   */
  providers: AdvertisingProviderConfig[];
};

/**
 * @generated from message guardianai.v1.admin.GetAdvertisingTrackingConfigResponse
 */
export type GetAdvertisingTrackingConfigResponseJson = {
  /**
   * @generated from field: repeated guardianai.v1.admin.AdvertisingProviderConfig providers = 1;
   */
  providers?: AdvertisingProviderConfigJson[];
};

/**
 * Describes the message guardianai.v1.admin.GetAdvertisingTrackingConfigResponse.
 * Use `create(GetAdvertisingTrackingConfigResponseSchema)` to create a new message.
 */
export const GetAdvertisingTrackingConfigResponseSchema: GenMessage<GetAdvertisingTrackingConfigResponse, {jsonType: GetAdvertisingTrackingConfigResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_ad_funnel, 53);

/**
 * @generated from message guardianai.v1.admin.UpdateAdvertisingTrackingConfigRequest
 */
export type UpdateAdvertisingTrackingConfigRequest = Message<"guardianai.v1.admin.UpdateAdvertisingTrackingConfigRequest"> & {
  /**
   * @generated from field: string landing_page_kind = 1;
   */
  landingPageKind: string;

  /**
   * @generated from field: string landing_page_id = 2;
   */
  landingPageId: string;

  /**
   * @generated from field: string landing_page_url = 3;
   */
  landingPageUrl: string;

  /**
   * @generated from field: repeated guardianai.v1.admin.AdvertisingProviderConfig providers = 4;
   */
  providers: AdvertisingProviderConfig[];
};

/**
 * @generated from message guardianai.v1.admin.UpdateAdvertisingTrackingConfigRequest
 */
export type UpdateAdvertisingTrackingConfigRequestJson = {
  /**
   * @generated from field: string landing_page_kind = 1;
   */
  landingPageKind?: string;

  /**
   * @generated from field: string landing_page_id = 2;
   */
  landingPageId?: string;

  /**
   * @generated from field: string landing_page_url = 3;
   */
  landingPageUrl?: string;

  /**
   * @generated from field: repeated guardianai.v1.admin.AdvertisingProviderConfig providers = 4;
   */
  providers?: AdvertisingProviderConfigJson[];
};

/**
 * Describes the message guardianai.v1.admin.UpdateAdvertisingTrackingConfigRequest.
 * Use `create(UpdateAdvertisingTrackingConfigRequestSchema)` to create a new message.
 */
export const UpdateAdvertisingTrackingConfigRequestSchema: GenMessage<UpdateAdvertisingTrackingConfigRequest, {jsonType: UpdateAdvertisingTrackingConfigRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_ad_funnel, 54);

/**
 * @generated from message guardianai.v1.admin.RotateAdvertisingSourceTokenRequest
 */
export type RotateAdvertisingSourceTokenRequest = Message<"guardianai.v1.admin.RotateAdvertisingSourceTokenRequest"> & {
  /**
   * @generated from field: string landing_page_kind = 1;
   */
  landingPageKind: string;

  /**
   * @generated from field: string landing_page_id = 2;
   */
  landingPageId: string;

  /**
   * @generated from field: string landing_page_url = 3;
   */
  landingPageUrl: string;

  /**
   * @generated from field: guardianai.v1.admin.AdvertisingProvider provider = 4;
   */
  provider: AdvertisingProvider;
};

/**
 * @generated from message guardianai.v1.admin.RotateAdvertisingSourceTokenRequest
 */
export type RotateAdvertisingSourceTokenRequestJson = {
  /**
   * @generated from field: string landing_page_kind = 1;
   */
  landingPageKind?: string;

  /**
   * @generated from field: string landing_page_id = 2;
   */
  landingPageId?: string;

  /**
   * @generated from field: string landing_page_url = 3;
   */
  landingPageUrl?: string;

  /**
   * @generated from field: guardianai.v1.admin.AdvertisingProvider provider = 4;
   */
  provider?: AdvertisingProviderJson;
};

/**
 * Describes the message guardianai.v1.admin.RotateAdvertisingSourceTokenRequest.
 * Use `create(RotateAdvertisingSourceTokenRequestSchema)` to create a new message.
 */
export const RotateAdvertisingSourceTokenRequestSchema: GenMessage<RotateAdvertisingSourceTokenRequest, {jsonType: RotateAdvertisingSourceTokenRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_ad_funnel, 55);

/**
 * @generated from message guardianai.v1.admin.RotateAdvertisingSourceTokenResponse
 */
export type RotateAdvertisingSourceTokenResponse = Message<"guardianai.v1.admin.RotateAdvertisingSourceTokenResponse"> & {
  /**
   * @generated from field: string campaign_destination_url = 1;
   */
  campaignDestinationUrl: string;
};

/**
 * @generated from message guardianai.v1.admin.RotateAdvertisingSourceTokenResponse
 */
export type RotateAdvertisingSourceTokenResponseJson = {
  /**
   * @generated from field: string campaign_destination_url = 1;
   */
  campaignDestinationUrl?: string;
};

/**
 * Describes the message guardianai.v1.admin.RotateAdvertisingSourceTokenResponse.
 * Use `create(RotateAdvertisingSourceTokenResponseSchema)` to create a new message.
 */
export const RotateAdvertisingSourceTokenResponseSchema: GenMessage<RotateAdvertisingSourceTokenResponse, {jsonType: RotateAdvertisingSourceTokenResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_ad_funnel, 56);

/**
 * @generated from message guardianai.v1.admin.ResolveAdvertisingAttributionRequest
 */
export type ResolveAdvertisingAttributionRequest = Message<"guardianai.v1.admin.ResolveAdvertisingAttributionRequest"> & {
  /**
   * @generated from field: string landing_page_kind = 1;
   */
  landingPageKind: string;

  /**
   * @generated from field: string landing_page_id = 2;
   */
  landingPageId: string;

  /**
   * @generated from field: string visitor_id = 3;
   */
  visitorId: string;

  /**
   * @generated from field: string session_id = 4;
   */
  sessionId: string;

  /**
   * @generated from field: string source_token = 5;
   */
  sourceToken: string;

  /**
   * @generated from field: string gclid = 6;
   */
  gclid: string;

  /**
   * @generated from field: string gbraid = 7;
   */
  gbraid: string;

  /**
   * @generated from field: string wbraid = 8;
   */
  wbraid: string;

  /**
   * @generated from field: string oppref = 9;
   */
  oppref: string;

  /**
   * @generated from field: string msclkid = 10;
   */
  msclkid: string;

  /**
   * @generated from field: string utm_source = 11;
   */
  utmSource: string;

  /**
   * @generated from field: string utm_medium = 12;
   */
  utmMedium: string;

  /**
   * @generated from field: string utm_campaign = 13;
   */
  utmCampaign: string;

  /**
   * @generated from field: string utm_content = 14;
   */
  utmContent: string;

  /**
   * @generated from field: string utm_term = 15;
   */
  utmTerm: string;

  /**
   * @generated from field: string page_url = 16;
   */
  pageUrl: string;

  /**
   * @generated from field: string referrer = 17;
   */
  referrer: string;

  /**
   * @generated from field: guardianai.v1.admin.AdvertisingConsentState consent_state = 18;
   */
  consentState: AdvertisingConsentState;
};

/**
 * @generated from message guardianai.v1.admin.ResolveAdvertisingAttributionRequest
 */
export type ResolveAdvertisingAttributionRequestJson = {
  /**
   * @generated from field: string landing_page_kind = 1;
   */
  landingPageKind?: string;

  /**
   * @generated from field: string landing_page_id = 2;
   */
  landingPageId?: string;

  /**
   * @generated from field: string visitor_id = 3;
   */
  visitorId?: string;

  /**
   * @generated from field: string session_id = 4;
   */
  sessionId?: string;

  /**
   * @generated from field: string source_token = 5;
   */
  sourceToken?: string;

  /**
   * @generated from field: string gclid = 6;
   */
  gclid?: string;

  /**
   * @generated from field: string gbraid = 7;
   */
  gbraid?: string;

  /**
   * @generated from field: string wbraid = 8;
   */
  wbraid?: string;

  /**
   * @generated from field: string oppref = 9;
   */
  oppref?: string;

  /**
   * @generated from field: string msclkid = 10;
   */
  msclkid?: string;

  /**
   * @generated from field: string utm_source = 11;
   */
  utmSource?: string;

  /**
   * @generated from field: string utm_medium = 12;
   */
  utmMedium?: string;

  /**
   * @generated from field: string utm_campaign = 13;
   */
  utmCampaign?: string;

  /**
   * @generated from field: string utm_content = 14;
   */
  utmContent?: string;

  /**
   * @generated from field: string utm_term = 15;
   */
  utmTerm?: string;

  /**
   * @generated from field: string page_url = 16;
   */
  pageUrl?: string;

  /**
   * @generated from field: string referrer = 17;
   */
  referrer?: string;

  /**
   * @generated from field: guardianai.v1.admin.AdvertisingConsentState consent_state = 18;
   */
  consentState?: AdvertisingConsentStateJson;
};

/**
 * Describes the message guardianai.v1.admin.ResolveAdvertisingAttributionRequest.
 * Use `create(ResolveAdvertisingAttributionRequestSchema)` to create a new message.
 */
export const ResolveAdvertisingAttributionRequestSchema: GenMessage<ResolveAdvertisingAttributionRequest, {jsonType: ResolveAdvertisingAttributionRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_ad_funnel, 57);

/**
 * @generated from message guardianai.v1.admin.ResolveAdvertisingAttributionResponse
 */
export type ResolveAdvertisingAttributionResponse = Message<"guardianai.v1.admin.ResolveAdvertisingAttributionResponse"> & {
  /**
   * @generated from field: guardianai.v1.admin.AdvertisingAcquisitionContext attribution = 1;
   */
  attribution?: AdvertisingAcquisitionContext;

  /**
   * @generated from field: guardianai.v1.admin.AdvertisingProviderConfig eligible_provider = 2;
   */
  eligibleProvider?: AdvertisingProviderConfig;
};

/**
 * @generated from message guardianai.v1.admin.ResolveAdvertisingAttributionResponse
 */
export type ResolveAdvertisingAttributionResponseJson = {
  /**
   * @generated from field: guardianai.v1.admin.AdvertisingAcquisitionContext attribution = 1;
   */
  attribution?: AdvertisingAcquisitionContextJson;

  /**
   * @generated from field: guardianai.v1.admin.AdvertisingProviderConfig eligible_provider = 2;
   */
  eligibleProvider?: AdvertisingProviderConfigJson;
};

/**
 * Describes the message guardianai.v1.admin.ResolveAdvertisingAttributionResponse.
 * Use `create(ResolveAdvertisingAttributionResponseSchema)` to create a new message.
 */
export const ResolveAdvertisingAttributionResponseSchema: GenMessage<ResolveAdvertisingAttributionResponse, {jsonType: ResolveAdvertisingAttributionResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_ad_funnel, 58);

/**
 * @generated from message guardianai.v1.admin.RecordAdvertisingEventRequest
 */
export type RecordAdvertisingEventRequest = Message<"guardianai.v1.admin.RecordAdvertisingEventRequest"> & {
  /**
   * @generated from field: string event_id = 1;
   */
  eventId: string;

  /**
   * @generated from field: guardianai.v1.admin.CanonicalAdvertisingEventType event_type = 2;
   */
  eventType: CanonicalAdvertisingEventType;

  /**
   * @generated from field: string landing_page_kind = 3;
   */
  landingPageKind: string;

  /**
   * @generated from field: string landing_page_id = 4;
   */
  landingPageId: string;

  /**
   * @generated from field: string visitor_id = 5;
   */
  visitorId: string;

  /**
   * @generated from field: string session_id = 6;
   */
  sessionId: string;

  /**
   * @generated from field: string acquisition_context_id = 7;
   */
  acquisitionContextId: string;

  /**
   * @generated from field: string element_id = 8;
   */
  elementId: string;

  /**
   * @generated from field: google.protobuf.Timestamp occurred_at = 9;
   */
  occurredAt?: Timestamp;

  /**
   * @generated from field: string page_url = 10;
   */
  pageUrl: string;

  /**
   * @generated from field: double value = 11;
   */
  value: number;

  /**
   * @generated from field: string currency = 12;
   */
  currency: string;

  /**
   * @generated from field: string metadata_json = 13;
   */
  metadataJson: string;

  /**
   * @generated from field: guardianai.v1.admin.AdvertisingConsentState consent_state = 14;
   */
  consentState: AdvertisingConsentState;
};

/**
 * @generated from message guardianai.v1.admin.RecordAdvertisingEventRequest
 */
export type RecordAdvertisingEventRequestJson = {
  /**
   * @generated from field: string event_id = 1;
   */
  eventId?: string;

  /**
   * @generated from field: guardianai.v1.admin.CanonicalAdvertisingEventType event_type = 2;
   */
  eventType?: CanonicalAdvertisingEventTypeJson;

  /**
   * @generated from field: string landing_page_kind = 3;
   */
  landingPageKind?: string;

  /**
   * @generated from field: string landing_page_id = 4;
   */
  landingPageId?: string;

  /**
   * @generated from field: string visitor_id = 5;
   */
  visitorId?: string;

  /**
   * @generated from field: string session_id = 6;
   */
  sessionId?: string;

  /**
   * @generated from field: string acquisition_context_id = 7;
   */
  acquisitionContextId?: string;

  /**
   * @generated from field: string element_id = 8;
   */
  elementId?: string;

  /**
   * @generated from field: google.protobuf.Timestamp occurred_at = 9;
   */
  occurredAt?: TimestampJson;

  /**
   * @generated from field: string page_url = 10;
   */
  pageUrl?: string;

  /**
   * @generated from field: double value = 11;
   */
  value?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: string currency = 12;
   */
  currency?: string;

  /**
   * @generated from field: string metadata_json = 13;
   */
  metadataJson?: string;

  /**
   * @generated from field: guardianai.v1.admin.AdvertisingConsentState consent_state = 14;
   */
  consentState?: AdvertisingConsentStateJson;
};

/**
 * Describes the message guardianai.v1.admin.RecordAdvertisingEventRequest.
 * Use `create(RecordAdvertisingEventRequestSchema)` to create a new message.
 */
export const RecordAdvertisingEventRequestSchema: GenMessage<RecordAdvertisingEventRequest, {jsonType: RecordAdvertisingEventRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_ad_funnel, 59);

/**
 * @generated from message guardianai.v1.admin.RecordAdvertisingEventResponse
 */
export type RecordAdvertisingEventResponse = Message<"guardianai.v1.admin.RecordAdvertisingEventResponse"> & {
  /**
   * @generated from field: guardianai.v1.admin.AdvertisingProvider provider_owner = 1;
   */
  providerOwner: AdvertisingProvider;

  /**
   * @generated from field: string attribution_status = 2;
   */
  attributionStatus: string;

  /**
   * @generated from field: string dispatch_status = 3;
   */
  dispatchStatus: string;

  /**
   * @generated from field: bool duplicate = 4;
   */
  duplicate: boolean;

  /**
   * @generated from field: guardianai.v1.admin.AdvertisingProviderConfig eligible_provider = 5;
   */
  eligibleProvider?: AdvertisingProviderConfig;
};

/**
 * @generated from message guardianai.v1.admin.RecordAdvertisingEventResponse
 */
export type RecordAdvertisingEventResponseJson = {
  /**
   * @generated from field: guardianai.v1.admin.AdvertisingProvider provider_owner = 1;
   */
  providerOwner?: AdvertisingProviderJson;

  /**
   * @generated from field: string attribution_status = 2;
   */
  attributionStatus?: string;

  /**
   * @generated from field: string dispatch_status = 3;
   */
  dispatchStatus?: string;

  /**
   * @generated from field: bool duplicate = 4;
   */
  duplicate?: boolean;

  /**
   * @generated from field: guardianai.v1.admin.AdvertisingProviderConfig eligible_provider = 5;
   */
  eligibleProvider?: AdvertisingProviderConfigJson;
};

/**
 * Describes the message guardianai.v1.admin.RecordAdvertisingEventResponse.
 * Use `create(RecordAdvertisingEventResponseSchema)` to create a new message.
 */
export const RecordAdvertisingEventResponseSchema: GenMessage<RecordAdvertisingEventResponse, {jsonType: RecordAdvertisingEventResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_ad_funnel, 60);

/**
 * @generated from enum guardianai.v1.admin.FunnelType
 */
export enum FunnelType {
  /**
   * @generated from enum value: FUNNEL_TYPE_UNSPECIFIED = 0;
   */
  FUNNEL_TYPE_UNSPECIFIED = 0,

  /**
   * @generated from enum value: YOUTUBE_VIDEO = 1;
   */
  YOUTUBE_VIDEO = 1,

  /**
   * @generated from enum value: BOOK = 2;
   */
  BOOK = 2,

  /**
   * @generated from enum value: INTERNAL_SERVICE = 3;
   */
  INTERNAL_SERVICE = 3,

  /**
   * @generated from enum value: MARKETPLACE_APP = 4;
   */
  MARKETPLACE_APP = 4,

  /**
   * @generated from enum value: MOBILE_APP = 5;
   */
  MOBILE_APP = 5,
}

/**
 * @generated from enum guardianai.v1.admin.FunnelType
 */
export type FunnelTypeJson = "FUNNEL_TYPE_UNSPECIFIED" | "YOUTUBE_VIDEO" | "BOOK" | "INTERNAL_SERVICE" | "MARKETPLACE_APP" | "MOBILE_APP";

/**
 * Describes the enum guardianai.v1.admin.FunnelType.
 */
export const FunnelTypeSchema: GenEnum<FunnelType, FunnelTypeJson> = /*@__PURE__*/
  enumDesc(file_guardianai_v1_admin_ad_funnel, 0);

/**
 * @generated from enum guardianai.v1.admin.ProductType
 */
export enum ProductType {
  /**
   * @generated from enum value: PRODUCT_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * e.g. Family Care
   *
   * @generated from enum value: PRODUCT_TYPE_INTERNAL_SERVICE = 1;
   */
  INTERNAL_SERVICE = 1,

  /**
   * e.g. Wix app, Shopify app
   *
   * @generated from enum value: PRODUCT_TYPE_MARKETPLACE_APP = 2;
   */
  MARKETPLACE_APP = 2,

  /**
   * e.g. iOS/Android app
   *
   * @generated from enum value: PRODUCT_TYPE_MOBILE_APP = 3;
   */
  MOBILE_APP = 3,
}

/**
 * @generated from enum guardianai.v1.admin.ProductType
 */
export type ProductTypeJson = "PRODUCT_TYPE_UNSPECIFIED" | "PRODUCT_TYPE_INTERNAL_SERVICE" | "PRODUCT_TYPE_MARKETPLACE_APP" | "PRODUCT_TYPE_MOBILE_APP";

/**
 * Describes the enum guardianai.v1.admin.ProductType.
 */
export const ProductTypeSchema: GenEnum<ProductType, ProductTypeJson> = /*@__PURE__*/
  enumDesc(file_guardianai_v1_admin_ad_funnel, 1);

/**
 * @generated from enum guardianai.v1.admin.CampaignStatus
 */
export enum CampaignStatus {
  /**
   * @generated from enum value: CAMPAIGN_STATUS_UNSPECIFIED = 0;
   */
  CAMPAIGN_STATUS_UNSPECIFIED = 0,

  /**
   * @generated from enum value: DRAFT = 1;
   */
  DRAFT = 1,

  /**
   * @generated from enum value: PREVIEW = 2;
   */
  PREVIEW = 2,

  /**
   * @generated from enum value: SCHEDULED = 3;
   */
  SCHEDULED = 3,

  /**
   * @generated from enum value: PUBLISHED = 4;
   */
  PUBLISHED = 4,

  /**
   * @generated from enum value: PAUSED = 5;
   */
  PAUSED = 5,

  /**
   * @generated from enum value: ARCHIVED = 6;
   */
  ARCHIVED = 6,
}

/**
 * @generated from enum guardianai.v1.admin.CampaignStatus
 */
export type CampaignStatusJson = "CAMPAIGN_STATUS_UNSPECIFIED" | "DRAFT" | "PREVIEW" | "SCHEDULED" | "PUBLISHED" | "PAUSED" | "ARCHIVED";

/**
 * Describes the enum guardianai.v1.admin.CampaignStatus.
 */
export const CampaignStatusSchema: GenEnum<CampaignStatus, CampaignStatusJson> = /*@__PURE__*/
  enumDesc(file_guardianai_v1_admin_ad_funnel, 2);

/**
 * @generated from enum guardianai.v1.admin.AdvertisingProvider
 */
export enum AdvertisingProvider {
  /**
   * @generated from enum value: ADVERTISING_PROVIDER_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: ADVERTISING_PROVIDER_GOOGLE_ADS = 1;
   */
  GOOGLE_ADS = 1,

  /**
   * @generated from enum value: ADVERTISING_PROVIDER_OPENAI_ADS = 2;
   */
  OPENAI_ADS = 2,

  /**
   * @generated from enum value: ADVERTISING_PROVIDER_MICROSOFT_ADS = 3;
   */
  MICROSOFT_ADS = 3,

  /**
   * @generated from enum value: ADVERTISING_PROVIDER_NONE = 4;
   */
  NONE = 4,

  /**
   * @generated from enum value: ADVERTISING_PROVIDER_CONFLICT = 5;
   */
  CONFLICT = 5,
}

/**
 * @generated from enum guardianai.v1.admin.AdvertisingProvider
 */
export type AdvertisingProviderJson = "ADVERTISING_PROVIDER_UNSPECIFIED" | "ADVERTISING_PROVIDER_GOOGLE_ADS" | "ADVERTISING_PROVIDER_OPENAI_ADS" | "ADVERTISING_PROVIDER_MICROSOFT_ADS" | "ADVERTISING_PROVIDER_NONE" | "ADVERTISING_PROVIDER_CONFLICT";

/**
 * Describes the enum guardianai.v1.admin.AdvertisingProvider.
 */
export const AdvertisingProviderSchema: GenEnum<AdvertisingProvider, AdvertisingProviderJson> = /*@__PURE__*/
  enumDesc(file_guardianai_v1_admin_ad_funnel, 3);

/**
 * @generated from enum guardianai.v1.admin.AdvertisingTrackingMode
 */
export enum AdvertisingTrackingMode {
  /**
   * @generated from enum value: ADVERTISING_TRACKING_MODE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: ADVERTISING_TRACKING_MODE_BROWSER = 1;
   */
  BROWSER = 1,

  /**
   * @generated from enum value: ADVERTISING_TRACKING_MODE_HYBRID = 2;
   */
  HYBRID = 2,
}

/**
 * @generated from enum guardianai.v1.admin.AdvertisingTrackingMode
 */
export type AdvertisingTrackingModeJson = "ADVERTISING_TRACKING_MODE_UNSPECIFIED" | "ADVERTISING_TRACKING_MODE_BROWSER" | "ADVERTISING_TRACKING_MODE_HYBRID";

/**
 * Describes the enum guardianai.v1.admin.AdvertisingTrackingMode.
 */
export const AdvertisingTrackingModeSchema: GenEnum<AdvertisingTrackingMode, AdvertisingTrackingModeJson> = /*@__PURE__*/
  enumDesc(file_guardianai_v1_admin_ad_funnel, 4);

/**
 * @generated from enum guardianai.v1.admin.CanonicalAdvertisingEventType
 */
export enum CanonicalAdvertisingEventType {
  /**
   * @generated from enum value: CANONICAL_ADVERTISING_EVENT_UNSPECIFIED = 0;
   */
  CANONICAL_ADVERTISING_EVENT_UNSPECIFIED = 0,

  /**
   * @generated from enum value: CANONICAL_ADVERTISING_EVENT_PAGE_VIEW = 1;
   */
  CANONICAL_ADVERTISING_EVENT_PAGE_VIEW = 1,

  /**
   * @generated from enum value: CANONICAL_ADVERTISING_EVENT_PRIMARY_CTA_CLICK = 2;
   */
  CANONICAL_ADVERTISING_EVENT_PRIMARY_CTA_CLICK = 2,

  /**
   * @generated from enum value: CANONICAL_ADVERTISING_EVENT_BOOK_CONSULTATION_CLICK = 3;
   */
  CANONICAL_ADVERTISING_EVENT_BOOK_CONSULTATION_CLICK = 3,

  /**
   * @generated from enum value: CANONICAL_ADVERTISING_EVENT_CONTACT_US_CLICK = 4;
   */
  CANONICAL_ADVERTISING_EVENT_CONTACT_US_CLICK = 4,

  /**
   * @generated from enum value: CANONICAL_ADVERTISING_EVENT_PHONE_CLICK = 5;
   */
  CANONICAL_ADVERTISING_EVENT_PHONE_CLICK = 5,

  /**
   * @generated from enum value: CANONICAL_ADVERTISING_EVENT_EMAIL_CLICK = 6;
   */
  CANONICAL_ADVERTISING_EVENT_EMAIL_CLICK = 6,

  /**
   * @generated from enum value: CANONICAL_ADVERTISING_EVENT_DOWNLOAD_CLICK = 7;
   */
  CANONICAL_ADVERTISING_EVENT_DOWNLOAD_CLICK = 7,

  /**
   * @generated from enum value: CANONICAL_ADVERTISING_EVENT_LEAD_FORM_STARTED = 8;
   */
  CANONICAL_ADVERTISING_EVENT_LEAD_FORM_STARTED = 8,

  /**
   * @generated from enum value: CANONICAL_ADVERTISING_EVENT_LEAD_FORM_SUBMITTED = 9;
   */
  CANONICAL_ADVERTISING_EVENT_LEAD_FORM_SUBMITTED = 9,

  /**
   * @generated from enum value: CANONICAL_ADVERTISING_EVENT_APPOINTMENT_SCHEDULED = 10;
   */
  CANONICAL_ADVERTISING_EVENT_APPOINTMENT_SCHEDULED = 10,

  /**
   * @generated from enum value: CANONICAL_ADVERTISING_EVENT_PURCHASE_COMPLETED = 11;
   */
  CANONICAL_ADVERTISING_EVENT_PURCHASE_COMPLETED = 11,

  /**
   * @generated from enum value: CANONICAL_ADVERTISING_EVENT_OUTBOUND_CLICK = 12;
   */
  CANONICAL_ADVERTISING_EVENT_OUTBOUND_CLICK = 12,

  /**
   * @generated from enum value: CANONICAL_ADVERTISING_EVENT_PAYMENT_CLICK = 13;
   */
  CANONICAL_ADVERTISING_EVENT_PAYMENT_CLICK = 13,
}

/**
 * @generated from enum guardianai.v1.admin.CanonicalAdvertisingEventType
 */
export type CanonicalAdvertisingEventTypeJson = "CANONICAL_ADVERTISING_EVENT_UNSPECIFIED" | "CANONICAL_ADVERTISING_EVENT_PAGE_VIEW" | "CANONICAL_ADVERTISING_EVENT_PRIMARY_CTA_CLICK" | "CANONICAL_ADVERTISING_EVENT_BOOK_CONSULTATION_CLICK" | "CANONICAL_ADVERTISING_EVENT_CONTACT_US_CLICK" | "CANONICAL_ADVERTISING_EVENT_PHONE_CLICK" | "CANONICAL_ADVERTISING_EVENT_EMAIL_CLICK" | "CANONICAL_ADVERTISING_EVENT_DOWNLOAD_CLICK" | "CANONICAL_ADVERTISING_EVENT_LEAD_FORM_STARTED" | "CANONICAL_ADVERTISING_EVENT_LEAD_FORM_SUBMITTED" | "CANONICAL_ADVERTISING_EVENT_APPOINTMENT_SCHEDULED" | "CANONICAL_ADVERTISING_EVENT_PURCHASE_COMPLETED" | "CANONICAL_ADVERTISING_EVENT_OUTBOUND_CLICK" | "CANONICAL_ADVERTISING_EVENT_PAYMENT_CLICK";

/**
 * Describes the enum guardianai.v1.admin.CanonicalAdvertisingEventType.
 */
export const CanonicalAdvertisingEventTypeSchema: GenEnum<CanonicalAdvertisingEventType, CanonicalAdvertisingEventTypeJson> = /*@__PURE__*/
  enumDesc(file_guardianai_v1_admin_ad_funnel, 5);

/**
 * @generated from enum guardianai.v1.admin.AdvertisingAttributionConfidence
 */
export enum AdvertisingAttributionConfidence {
  /**
   * @generated from enum value: ADVERTISING_ATTRIBUTION_CONFIDENCE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: ADVERTISING_ATTRIBUTION_CONFIDENCE_VERIFIED = 1;
   */
  VERIFIED = 1,

  /**
   * @generated from enum value: ADVERTISING_ATTRIBUTION_CONFIDENCE_HIGH = 2;
   */
  HIGH = 2,

  /**
   * @generated from enum value: ADVERTISING_ATTRIBUTION_CONFIDENCE_MEDIUM = 3;
   */
  MEDIUM = 3,

  /**
   * @generated from enum value: ADVERTISING_ATTRIBUTION_CONFIDENCE_NONE = 4;
   */
  NONE = 4,

  /**
   * @generated from enum value: ADVERTISING_ATTRIBUTION_CONFIDENCE_CONFLICT = 5;
   */
  CONFLICT = 5,
}

/**
 * @generated from enum guardianai.v1.admin.AdvertisingAttributionConfidence
 */
export type AdvertisingAttributionConfidenceJson = "ADVERTISING_ATTRIBUTION_CONFIDENCE_UNSPECIFIED" | "ADVERTISING_ATTRIBUTION_CONFIDENCE_VERIFIED" | "ADVERTISING_ATTRIBUTION_CONFIDENCE_HIGH" | "ADVERTISING_ATTRIBUTION_CONFIDENCE_MEDIUM" | "ADVERTISING_ATTRIBUTION_CONFIDENCE_NONE" | "ADVERTISING_ATTRIBUTION_CONFIDENCE_CONFLICT";

/**
 * Describes the enum guardianai.v1.admin.AdvertisingAttributionConfidence.
 */
export const AdvertisingAttributionConfidenceSchema: GenEnum<AdvertisingAttributionConfidence, AdvertisingAttributionConfidenceJson> = /*@__PURE__*/
  enumDesc(file_guardianai_v1_admin_ad_funnel, 6);

/**
 * @generated from enum guardianai.v1.admin.AdvertisingConsentState
 */
export enum AdvertisingConsentState {
  /**
   * @generated from enum value: ADVERTISING_CONSENT_STATE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: ADVERTISING_CONSENT_STATE_UNKNOWN = 1;
   */
  UNKNOWN = 1,

  /**
   * @generated from enum value: ADVERTISING_CONSENT_STATE_GRANTED = 2;
   */
  GRANTED = 2,

  /**
   * @generated from enum value: ADVERTISING_CONSENT_STATE_DENIED = 3;
   */
  DENIED = 3,
}

/**
 * @generated from enum guardianai.v1.admin.AdvertisingConsentState
 */
export type AdvertisingConsentStateJson = "ADVERTISING_CONSENT_STATE_UNSPECIFIED" | "ADVERTISING_CONSENT_STATE_UNKNOWN" | "ADVERTISING_CONSENT_STATE_GRANTED" | "ADVERTISING_CONSENT_STATE_DENIED";

/**
 * Describes the enum guardianai.v1.admin.AdvertisingConsentState.
 */
export const AdvertisingConsentStateSchema: GenEnum<AdvertisingConsentState, AdvertisingConsentStateJson> = /*@__PURE__*/
  enumDesc(file_guardianai_v1_admin_ad_funnel, 7);

/**
 * @generated from service guardianai.v1.admin.AdFunnelService
 */
export const AdFunnelService: GenService<{
  /**
   * Create a new ad funnel
   *
   * @generated from rpc guardianai.v1.admin.AdFunnelService.CreateAdFunnel
   */
  createAdFunnel: {
    methodKind: "unary";
    input: typeof CreateAdFunnelRequestSchema;
    output: typeof GetAdFunnelResponseSchema;
  },
  /**
   * List all ad funnels
   *
   * @generated from rpc guardianai.v1.admin.AdFunnelService.ListAdFunnels
   */
  listAdFunnels: {
    methodKind: "unary";
    input: typeof ListAdFunnelsRequestSchema;
    output: typeof ListAdFunnelsResponseSchema;
  },
  /**
   * Get an ad funnel by ID (public access for rendering)
   *
   * @generated from rpc guardianai.v1.admin.AdFunnelService.GetAdFunnel
   */
  getAdFunnel: {
    methodKind: "unary";
    input: typeof GetAdFunnelRequestSchema;
    output: typeof GetAdFunnelResponseSchema;
  },
  /**
   * Update an existing ad funnel
   *
   * @generated from rpc guardianai.v1.admin.AdFunnelService.UpdateAdFunnel
   */
  updateAdFunnel: {
    methodKind: "unary";
    input: typeof UpdateAdFunnelRequestSchema;
    output: typeof GetAdFunnelResponseSchema;
  },
  /**
   * Delete an ad funnel and its associated events
   *
   * @generated from rpc guardianai.v1.admin.AdFunnelService.DeleteAdFunnel
   */
  deleteAdFunnel: {
    methodKind: "unary";
    input: typeof DeleteAdFunnelRequestSchema;
    output: typeof DeleteAdFunnelResponseSchema;
  },
  /**
   * High-throughput event tracking (fire and forget)
   *
   * @generated from rpc guardianai.v1.admin.AdFunnelService.TrackAdFunnelEvent
   */
  trackAdFunnelEvent: {
    methodKind: "unary";
    input: typeof TrackAdFunnelEventRequestSchema;
    output: typeof TrackAdFunnelEventResponseSchema;
  },
  /**
   * Retrieve aggregated statistics for the showroom dashboard
   *
   * @generated from rpc guardianai.v1.admin.AdFunnelService.GetAdFunnelStats
   */
  getAdFunnelStats: {
    methodKind: "unary";
    input: typeof GetAdFunnelStatsRequestSchema;
    output: typeof GetAdFunnelStatsResponseSchema;
  },
  /**
   * Book CRUD
   *
   * @generated from rpc guardianai.v1.admin.AdFunnelService.CreateBook
   */
  createBook: {
    methodKind: "unary";
    input: typeof CreateBookRequestSchema;
    output: typeof GetBookResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.admin.AdFunnelService.UpdateBook
   */
  updateBook: {
    methodKind: "unary";
    input: typeof UpdateBookRequestSchema;
    output: typeof GetBookResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.admin.AdFunnelService.GetBook
   */
  getBook: {
    methodKind: "unary";
    input: typeof GetBookRequestSchema;
    output: typeof GetBookResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.admin.AdFunnelService.ListBooks
   */
  listBooks: {
    methodKind: "unary";
    input: typeof ListBooksRequestSchema;
    output: typeof ListBooksResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.admin.AdFunnelService.DeleteBook
   */
  deleteBook: {
    methodKind: "unary";
    input: typeof DeleteBookRequestSchema;
    output: typeof DeleteBookResponseSchema;
  },
  /**
   * Generic Product CRUD (Services, Marketplace Apps, Mobile Apps)
   *
   * @generated from rpc guardianai.v1.admin.AdFunnelService.CreateProduct
   */
  createProduct: {
    methodKind: "unary";
    input: typeof CreateProductRequestSchema;
    output: typeof GetProductResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.admin.AdFunnelService.UpdateProduct
   */
  updateProduct: {
    methodKind: "unary";
    input: typeof UpdateProductRequestSchema;
    output: typeof GetProductResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.admin.AdFunnelService.GetProduct
   */
  getProduct: {
    methodKind: "unary";
    input: typeof GetProductRequestSchema;
    output: typeof GetProductResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.admin.AdFunnelService.ListProducts
   */
  listProducts: {
    methodKind: "unary";
    input: typeof ListProductsRequestSchema;
    output: typeof ListProductsResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.admin.AdFunnelService.DeleteProduct
   */
  deleteProduct: {
    methodKind: "unary";
    input: typeof DeleteProductRequestSchema;
    output: typeof DeleteProductResponseSchema;
  },
  /**
   * Multi-platform paid advertising configuration and attribution.
   * Admin methods are authenticated; resolve/record methods are public landing-page APIs.
   *
   * @generated from rpc guardianai.v1.admin.AdFunnelService.GetAdvertisingTrackingConfig
   */
  getAdvertisingTrackingConfig: {
    methodKind: "unary";
    input: typeof GetAdvertisingTrackingConfigRequestSchema;
    output: typeof GetAdvertisingTrackingConfigResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.admin.AdFunnelService.UpdateAdvertisingTrackingConfig
   */
  updateAdvertisingTrackingConfig: {
    methodKind: "unary";
    input: typeof UpdateAdvertisingTrackingConfigRequestSchema;
    output: typeof GetAdvertisingTrackingConfigResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.admin.AdFunnelService.RotateAdvertisingSourceToken
   */
  rotateAdvertisingSourceToken: {
    methodKind: "unary";
    input: typeof RotateAdvertisingSourceTokenRequestSchema;
    output: typeof RotateAdvertisingSourceTokenResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.admin.AdFunnelService.ResolveAdvertisingAttribution
   */
  resolveAdvertisingAttribution: {
    methodKind: "unary";
    input: typeof ResolveAdvertisingAttributionRequestSchema;
    output: typeof ResolveAdvertisingAttributionResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.admin.AdFunnelService.RecordAdvertisingEvent
   */
  recordAdvertisingEvent: {
    methodKind: "unary";
    input: typeof RecordAdvertisingEventRequestSchema;
    output: typeof RecordAdvertisingEventResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_guardianai_v1_admin_ad_funnel, 0);

